import { Box, Modal, Typography } from "@mui/material";
import "../../CSS/ComponentCSS/TermsOfServiceAgreementModal.css";
import ButtonComponent from "../Inputs/ButtonComponent";
type TermsOfServiceAgreementProps = {
  open: boolean;
  onClose: (value: boolean) => void;
  cancel?: boolean;
  language: number;
};

export default function TermsOfServiceAgreement(
  props: TermsOfServiceAgreementProps
) {
  return (
    <Modal open={props.open} onClose={props.onClose}>
      <Box className="TermsOfServiceAgreementModalBox">
        <Typography variant="h4" style={{ marginBottom: "10px" }}>
          {props.language == 1
            ? "* 이용약관"
            : props.language == 2
            ? "* Terms of Use"
            : props.language == 3
            ? "* 利用規約"
            : props.language == 4
            ? "* 使用条款"
            : props.language == 5
            ? "* 使用條款"
            : ""}
        </Typography>
        {props.language == 1 ? (
          <Typography variant="body1">
            이용약관 2025년 05월 08일 시행 제1조 (목적) 1. 이 약관은 주식회사
            오콜로르(이하 '회사')가 제공하는 오콜로르 컨설팅 프로그램 서비스
            이용과 관련하여 회사와 회원과의 권리, 의무 및 책임사항, 기타 필요한
            사항을 규정함을 목적으로 합니다. 2. 회원은 본 서비스의 이용과
            관련하여 대한민국법의 적용을 받는 것에 동의합니다. 3. 회원은 회사에
            제공하는 정보 일체에 대하여 회사의 정보 수집 및 이용을 규율하는
            회사의 개인정보 처리방침이 적용됩니다. 회원은 서비스를 이용함으로써
            해당 정보의 대한민국 및/또는 기타 국가 내 보관, 처리 및 이용을 위한
            전송을 포함하여, (개인정보 처리방침에 기술된 바에 따른) 회사의 정보
            수집 및 이용에 동의합니다. 서비스 제공의 일환으로 회사는 서비스 공지
            및 관리 메시지와 같은 특정 커뮤니케이션을 발송할 수 있으며, 이러한
            커뮤니케이션은 서비스 및 회원의 서비스 계정의 일부로 간주되며, 그
            수신을 거부할 수 없습니다. 제2조 (정의) 본 약관에서 사용하는 용어의
            정의는 다음과 같습니다. 정의되지 않은 용어에 대한 해석은 관계 법령
            및 서비스 별 안내에 정하는 바에 의합니다. 관계법령과 서비스 별
            안내에서 정하지 않은 것은 일반적인 상관례에 따릅니다. 1. '서비스'라
            함은 설치되어 있는 단말기(휴대형 단말기, PC, TV 등의 각종 유무선
            장치를 포함)와 상관없이 '회원'이이 이용할 수 있는 오콜로르 컨설팅
            프로그램 및 오콜로르 컨설팅 프로그램 관련 기반 서비스를 의미합니다.
            2. 이용자란 회원가입을 하지 않고(비회원) 회사가 제공하는 서비스를
            이용하는 자를 말합니다. 3. '회원'이란 본 약관에 동의하여 회사가
            제공하는 서비스를 이용하는 자를 말합니다. 4. '서비스 이용자'는
            이용자 및 회원을 말합니다. 5. '컨텐츠'란 회원 또는 오콜로르에서
            제공되는 각종의 디지털 정보를 말합니다. 제 3조 (약관 등의 명시와
            설명 및 개정) 1. 회사는 이 약관의 내용을 서비스이용자가 쉽게 알 수
            있도록 회사에 게시하거나 기타의 방법으로 회원에게 공지함으로써
            효력이 발생합니다. 2. 회사는 약관의 규제에 관한 법률,
            정보통신망이용촉진 및 정보보호등에 관한 법률, 전자상거래 등에서의
            소비자보호에 관한 법률, 소비자기본법 등 관련법을 위배하지 않는
            범위에서 이 약관을 개정할 수 있습니다. 3. 회사가 약관을 개정 할
            경우에는 적용일자 및 개정사유를 명시하여 현행 약관과 함께 제 1항의
            방식에 따라 개정약관의 적용일자 30일 전부터 적용일자 전까지
            공지합니다. 다만, 회원의 권리 또는 의무에 관한 중요한 규정의 변경일
            경우에는 최소한 30일전에 공지하고 개정약관을 회원이 등록한 이메일로
            발송하여 통지합니다. 4. 회사가 전항에 따라 개정약관을 공지 또는
            통지하면서 약관 변경 적용일까지 거부의사를 표시하지 않으면
            의사표시가 표명된다는 내용을 알렸음에도 불구하고 회원이 명시적으로
            거부의사를 표시하지 아니하는 경우 회원이 개정약관에 동의한 것으로
            간주합니다. 5. 회원이 변경된 약관에 동의하지 않는 경우 회사는 개정
            약관의 내용을 적용할 수 없으며 이 경우 회원은 서비스의 이용을
            중단하고 이용계약을 해지 할 수 있습니다. 6. 이 약관에 동의하는 것은
            정기적으로 회사 및 모바일 어플리케이션을 통하여 약관의 변경사항 및
            운영방침 등을 확인하는 것에 동의하는 것을 의미합니다. 회원은 약관의
            변경에 대하여 주의의무를 다하여야 하며, 변경된 약관의 부지로 인한
            회원의 피해는 회사가 책임지지 않습니다. 제 4조 (개인정보보호) 1.
            회사는 이용자의 개인정보 수집 시 서비스제공을 위하여 필요한 범위에서
            최소한의 개인정보를 수집합니다. 2. 회사는 회원가입 시 서비스 운영에
            필요한 정보를 미리 수집하지 않습니다. 다만, 관련 법령상 의무이행을
            위하여 본인확인이 필요한 경우로서 최소한의 특정 개인정보를 수집하는
            경우에는 그러하지 아니합니다. 3. 회사는 서비스 이용자의 개인정보를
            수집·이용 시, 사전에 그 목적과 범위 등의 법령 상의 내용을 고지하고
            동의를 받습니다. 4. 회사는 수집된 개인정보를 서비스 운영 및 연구
            목적 외의 용도로 이용할 수 없으며, 새로운 이용목적이 발생한 경우
            또는 제3자에게 제공하는 경우에는 이용·제공단계에서 당해 이용자에게
            그 목적을 고지하고 동의를 받습니다. 다만, 관련 법령에 달리 정함이
            있는 경우에는 예외로 합니다. 5. 회사가 제2항과 제3항에 의해 서비스
            이용자의 동의를 받아야 하는 경우에는 개인정보관리 책임자의
            신원(소속, 성명 및 전화번호, 기타 연락처), 정보의 수집목적 및
            이용목적, 제3자에 대한 정보제공 관련사항(제공받은 자, 제공목적 및
            제공할 정보의 내용) 등 『개인정보 보호법』.「정보통신망 이용촉진 및
            정보보호 등에 관한 법률」이 규정한 사항을 미리 명시하거나 고지해야
            하며 이용자는 언제든지 이 동의를 철회할 수 있습니다. 6. 서비스
            이용자는 언제든지 회사가 가지고 있는 자신의 개인정보에 대해 열람 및
            오류정정을 요구할 수 있으며 회사는 이에 대해 지체 없이 필요한 조치를
            취할 의무를 집니다. 서비스 이용자가 오류의 정정을 요구한 경우에는
            회사는 그 오류를 정정할 때까지 당해 개인정보를 이용하지 않습니다. 7.
            회사는 개인정보 보호를 위하여 서비스 이용자의 개인정보를 취급하는
            자를 최소한으로 제한하여야 하며 서비스 이용자의 개인정보의 분실,
            도난, 유출, 동의 없는 제3자 제공, 변조 등으로 인한 서비스 이용자의
            손해에 대하여 모든 책임을 집니다. 8. 회사 또는 그로부터 개인정보를
            제공받은 제3자는 개인정보의 수집목적 또는 제공받은 목적을 달성한
            때에는 당해 개인정보를 지체 없이 파기합니다. 9. 회사는 개인정보의
            수집·이용·제공에 관한 동의란을 미리 선택한 것으로 설정해두지
            않습니다. 또한 개인정보의 수집·이용·제공에 관한 서비스 이용자의
            동의거절 시 제한되는 서비스를 구체적으로 명시하고, 필수수집항목이
            아닌 개인정보의 수집·이용·제공에 관한 동의 거절을 이유로 회원가입 등
            서비스 제공을 제한하거나 거절하지 않습니다. 10. 회원이 회사 또는
            서비스에 관하여 이메일 또는 그 외 방식으로 회사에 제공하는 피드백,
            제안, 아이디어 또는 기타 정보나 자료 등은 비밀정보가 아니며 회사의
            고유 재산임에 동의합니다. 회사는 회원에게 통지나 보상을 제공함이
            없이 상업성 여부를 불문한 어떠한 목적으로든 그러한 자료 및 정보들을
            무제한적으로 이용하거나 전파할 권리를 보유합니다. 회원은 회원이
            회사에게 제공한 다양한 정보 및 자료에 관하여 가질 수 있는
            권리(저작권 또는 저작인격권 포함) 일체를 포기하거나 회사에 주장하지
            않는 것에 동의합니다. 회사는 사용자의 의견을 환영하나, 보상을
            원하거나 그에 관한 소유권 또는 청구권을 지속적으로 보유하고자 하는
            경우에는 회사와 아이디어를 공유하지 않으시기 바랍니다. 제 5조
            (회원가입) 1. 이용자는 다음 각 호의 방법으로 회원가입을 신청합니다.
            다만, 회사는 운영하는 매체 및 서비스의 종류에 따라 별도의 회원가입
            신청 방법을 정할 수 있습니다. ①회사가 정한 가입 양식에 따라
            회원정보를 기입한 후 본 약관에 동의한다는 의사표시를 하는 방법 ②기타
            회사에서 정하는 방법 2. 회사는 제1항과 같이 회원으로 가입할 것을
            신청한 이용자 중 다음 각 호에 해당하지 않는 한 회원으로 등록합니다.
            ①가입신청자가 이 약관 제7조에 의하여 이전에 회원자격을 상실한 적이
            있는 경우. 다만 회사의 회원 재가입 승낙을 얻은 경우에는 예외로
            합니다. ②등록 내용에 허위, 기재누락, 오기가 있는 경우 ③기타 회원으로
            등록하는 것이 회사의 기술상 현저히 지장이 있다고 판단되는 경우 3.
            회원가입의 성립시기는 회사의 승낙이 회원에게 도달한 시점으로 합니다.
            4. 회원은 등록사항에 변경이 있는 경우, 상당한 기간 이내에 회사에
            대하여 회원정보 수정 등의 방법으로 그 변경사항을 알려야 합니다. 제
            6조 (회원 탈퇴 및 자격상실) 1. 회원은 회사에 언제든지 탈퇴를 요청할
            수 있으며 회사는 즉시 회원탈퇴를 처리합니다. 단, 회원탈퇴 시 회원이
            보유하고 있었던 개인적인 콘텐츠, 정보 등 회원으로서의 모든 혜택은
            소멸됩니다. 2. 탈퇴 전에 회원이 서비스를 위하여 또는 이와 관련하여
            지불한 사용료가 있는 경우, 그러한 사용료는 관련법령에서 정한 내용에
            따라 환불됩니다. 다만, 환불을 청구하지 않고 해지를 하는 경우 관련
            기록 삭제 등으로 인해 환불에 어려움이 발생할 수 있으니 해지 전
            필요한 환불 절차를 모두 이행하여 주시기를 부탁드립니다. 또한, 계정
            해지 시에도 이미 발생한 지불 의무는 면제되지는 않습니다. 3. 서비스가
            해지되거나 중단되는 경우, 회사는 이를 통지하고 콘텐츠 회수 기회를
            제공하기 위하여 합리적인 노력을 합니다. 4. 회원탈퇴 시 회원정보는
            지체 없이 파기합니다. 다만, 다음 사유의 경우에는 아래의 보존 이유를
            위해 명시한 기간 동안 보존합니다. ①관계 법령에 근거한 정보보유 사유
            가.국세기본법, 소비자기본법 등 ②회사 내부 방침에 근거한 정보보유
            사유 가. 보존 항목 : 전화번호, 생년월일, 성별, 이메일, 사진등 수집
            회원 정보 나. 보존 이유 : 부정 가입 및 이용 방지 부정 가입 : 타인
            명의를 도용하여 가입하거나 이벤트 응모를 목적으로 다수의 가성 회원
            다. 명의로 가입하는 경우 부정 이용 : 명의도용, 가성 회원가입으로
            부정한 목적의 거래행위(이벤트 응모 등)를 하는 경우와 컨텐츠 등 및
            Q&A 등에 욕설, 업체 홍보 글을 게시하는 경우 라.보존 기간 : 1개월 5.
            회원이 다음 각 호의 사유에 해당하는 경우, 회사는 회원자격을 제한 및
            정지시킬 수 있습니다. ①가입 신청 시에 허위 내용을 등록하거나 타인을
            정보를 도용한 경우 ②다른 사람의 회사 이용을 방해하거나 그 정보를
            도용하는 등 전자상거래 질서를 위협하는 경우 ③회사를 이용하여 법령
            또는 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우 ④다음
            각 목에 해당하는 행위를 하여 회사의 건전한 경영과 서비스 운영을
            방해하는 경우 가. 회사에 대한 근거 없는 허위의 사실을 유포하여
            회사의 명예를 실추시키는 경우 나. 회사의 직원에 대한 모욕, 폭언,
            협박, 성희롱 등으로 회사의 업무 운영을 방해하는 경우 다. 소비자원이
            고시한 소비자분쟁해결기준을 초과하는 과도한 보상을 상습적으로
            요청하는 경우 라. 회원이 게재하는 컨텐츠 등이 다음 각 호에 해당하는
            경우 1)타인의 권리나 명예, 신용 등 기타 정당한 이익을 침해하는 경우
            2)범죄 행위와 관련되거나, 공공질서 및 사회적 미풍양속에 위반되는
            내용일 경우 3)불법물, 음란물 또는 청소년 유해매체물의 게시, 광고,
            사이트를 링크하는 경우 4)회사가 제공하는 제품 및 서비스와 관련 없는
            내용일 경우 5)정보 통신 기기의 오작동을 일으킬 수 있는 악성 코드나
            데이터를 포함하는 경우 6)허위 정보인 경우 7)파트너사로부터 혜택을
            받은 생성된 컨텐츠이나 '광고','협찬' 등 당사가 제공한 운영정책에
            따라 표기하지 않은 경우 8)기타 본 이용약관, 당사가 제공하는 각종
            운영정책 또는 관련 법령에 위반하는 경우 6. 회원은 타 회원의 신고 및
            회사의 판단에 의해 계정 접근 및 계정 사용이 정지될 수 있습니다. 정지
            시점과 재사용 가능 여부는 회원에게 별도 고지 됩니다. 7. 회사가 회원
            자격을 제한 및 정지시킨 후, 동일한 행위가 2회 이상 반복되거나 30일
            이내에 그 사유가 시정되지 아니하는 경우 회사는 회원자격을 상실시킬
            수 있습니다. 회사가 회원자격을 상실시키는 경우에는 회원등록을
            말소합니다. 이 경우 회원에게 이를 통지하고, 회원등록 말소 전에
            최소한 30일 이상의 기간을 정하여 소명할 기회를 부여합니다. 제 7조
            (회원에 대한 통지) 1. 회사가 회원에 대한 통지를 하는 경우, 회원이
            회사와 미리 약정하여 지정한 SNS 계정, 전자우편 주소, 핸드폰번호(SMS,
            카카오톡 계정)로 할 수 있습니다. 2. 회사는 불특정다수 서비스
            이용자에 대한 통지의 경우 1주일 이상 서비스화면 또는 회사 내
            게시판에 게시함으로써 개별 통지에 갈음할 수 있습니다. 다만, 회원
            본인의 거래와 관련하여 중대한 영향을 미치는 사항에 대하여는 개별
            통지 합니다. 제 8조 (서비스의 제공 및 변경) 1. 회사는 다음 각 호의
            서비스 업무를 제공합니다. ① 컬러 분석 서비스 제공 ② 광고서비스업 ③
            기타 회사가 정하는 업무 2. 회사는 서비스 이용자와 파트너사 간에 재화
            등을 거래할 수 있도록 재화 등의 정보만을 제공하며, 회사는 파트너사가
            제공하는 재화 등의 정보 및 판매의 제반 행위에 관련해서는 일체의
            책임을 지지 않습니다. 제 9조 (서비스의 중단) 1. 회사는
            정보통신설비의 보수점검·교체 및 고장, 통신의 두절 등의 사유가 발생한
            경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다. 2. 회사는
            제1항 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자
            또는 제3자가 입은 손해에 대하여 배상합니다. 단, 회사가 고의 또는
            과실이 없음을 입증하는 경우에는 그러하지 아니합니다. 3. 사업종목의
            전환, 사업의 포기, 업체간의 통합 등의 이유로 서비스를 제공할 수 없게
            되는 경우에는 회사는 제8조에 정한 방법으로 회원에게 통지합니다. 제
            10조 (회사의 의무) 1. 회사는 법령과 이 약관이 금지하거나 공서양속에
            반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고,
            안정적으로 서비스를 제공하는데 최선을 다하여야 합니다. 2. 회사는
            서비스 이용자가 안전하게 회사의 서비스를 이용할 수 있도록 이용자의
            개인정보보호를 위한 보안 시스템을 갖추어야 합니다. 3. 회사는 서비스
            이용과 관련하여 회원으로부터 제기된 의견이나 불만이 정당하다고
            인정할 경우에는 이를 처리하여야 합니다. 4. 회사는 회원이 제기한
            의견이나 불만사항에 대해서는 게시판을 활용하거나 기타 회사가
            적당하다고 판단되는 방법 등을 통하여 회원에게 처리과정 및 결과를
            전달합니다. 제 11조 (회원의 ID 및 비밀번호에 대한 의무) 1. ID와
            비밀번호에 관한 관리책임은 회원에게 있습니다. 2. 회원은 자신의 ID 및
            비밀번호를 제3자에게 이용하게 해서는 안됩니다. 3. 회원이 자신의 ID
            및 비밀번호를 도난당하거나 제3자가 사용하고 있음을 인지한 경우에는
            바로 회사에 통보하고 회사의 안내가 있는 경우에는 그에 따라야 합니다.
            제 12조 (서비스 이용자의 의무) 1. 서비스 이용자는 다음 각 호의
            행위를 하여서는 안 됩니다. ①신청 또는 변경 시 허위 내용의 등록
            ②타인의 정보 도용 ③외설 또는 폭력적인 메시지, 이미지, 기타
            공서양속에 반하는 정보를 회사에 공개 또는 게시하는 행위 ④회사에
            게시된 정보의 변경 ⑤회사 및 기타 제3자의 지식재산권 등에 대한 침해
            ⑥타 법령 및 본 이용약관에 위반되는 불법적 행위 2. 서비스 이용자가 본
            조의 의무 사항을 위반하여 발생한 결과에 대해 회사는 책임을
            지지않습니다. 또한 회사에 손해가 발생한 경우 서비스 이용자는 회사에
            대한 손해배상 의무를 지며 회사는 해당 회원에 대해 서비스 이용정지 및
            적법한 절차를 거쳐 손해배상 등을 청구할 수 있습니다. 제 13조 (회원의
            책임) 1. 회원은 본인의 책임 하에 본 서비스 및 본 서비스에서 제공되는
            각종 컨텐츠 등을 이용하고 생성하며, 회원은 본 서비스를 통해 이루어진
            일체의 행위 및 그 결과에 대하여 책임을 집니다. 2. 회원은 회원이
            제작한 콘텐츠를 타인이 열람할 수 있으며 개인정보보호 설정의 조정을
            통해 콘텐츠에 대한 접근을 제한할 수 있음을 이해합니다. 3. 회원은
            자신의 사용자 콘텐츠 및 그로부터 발생하는 청구에 대하여 전적인
            책임을 부담하며 회사는 어떠한 사용자 콘텐츠 또는 그로부터 발생하는
            청구에 대해서도 책임 또는 법적 책임을 부담하지 않는 데에 동의합니다.
            4. 회사는 어느 때라도 이유를 불문하고 사용자 콘텐츠를 검토, 확인 및
            삭제할 권리와 완전한 재량을 보유하는 한편, 그에 대한 의무를 지지는
            않습니다. 5. 회원은 회원의 사용자 콘텐츠에 대한 소유권 일체를
            보유합니다. 그러나 사용자 콘텐츠를 회사에 제출함으로써 회원은
            알려지지 않았거나 추후 개발되는 것을 포함한 모든 매체 또는 배포
            방법을 이용하여 그러한 사용자 콘텐츠를 이용, 재현, 변경, 각색, 편집,
            출판, 2차 저작물 제작, 배포, 공연, 홍보, 전시 및 진열할 수 있는,
            취소 불가능하고 비독점적인, 전세계적, 영구적, 무상의, 2차 라이선스
            부여 및 양도 가능한 라이선스를 회사에 부여합니다. 6. 회원은 서비스에
            접근하거나 서비스를 이용함으로써 모욕적이거나 외설적이거나 기타
            불쾌한 것으로 간주되는 타인의 자료에 노출될 수 있음을 인정하고 이에
            동의하며, 그러한 위험을 감수하는 데에 동의합니다. 회사의 웹사이트
            또는 서비스를 통해 표현되는 견해는 반드시 회사의 견해를 대표하지는
            않습니다. 회사는 회원 또는 서비스이용자가 게시한 특정 콘텐츠를
            찬성하거나 지지하지 않습니다. 7. 회사는 콘텐츠 보호를 위해 가능한
            보안 조치를 제공할 것이나 콘텐츠의 공개로 인해 초래되는 손해에 대한
            책임을 지지 않습니다. 8. 회원은 다음 각호의 행위를 한 경우, 자신의
            책임과 비용으로 관련 분쟁을 해결하며, 이에 관하여 회사는 책임을 지지
            않습니다. ①허위·거짓정보·공공질서 및 미풍양속에 위반되는 컨텐츠 등을
            업로드·재생산 등을 하는 경우 ②업로드 된 컨텐츠 등이 타인의 명예를
            훼손하거나, 사생활을 침해할 경우 ③회사 또는 전자통신망 등에서 제
            3자의 사진 및 영상물 등을 공유 또는 유포하였을 경우 ④회원의 행위가
            타인의 지식재산권 및 관계 법령, 본 약관에 위반되는 행위인 경우 ⑤그
            밖의 사유로 타인의 권리를 침해한 경우 제 14조 (회원 등급) 회사는
            서비스를 이용하는 회원의 활동에 따라 회원 등급을 설정할 수 있으며,
            등급에 따라 서비스 이용 및 혜택지급에 차등을 둘 수 있다. 제 15조
            (앱내 화폐 제도) 1. 앱내 화폐는 회사가 운영하는 서비스 이용 과정에서
            발생하며 개별 활동에 따라 유효기간, 금액 등이 다르게 적용됩니다. 2.
            앱내 화폐은 고객의 환가성 자산이 아니므로 현금으로 환원되지 않으며,
            부정 행위를 통한 적립 발견 시 환원 및 소멸 조치될 수 있습니다. 3.
            앱내 화폐는 명시 된 기간 경과 시 자동 소멸됩니다. 구매된 앱내 화폐는
            다시 현금으로 재환원되지 않습니다. 4. 앱내 화폐는 회원의 탈퇴 및
            자격상실 시 소멸되며 복구되지 않습니다. 5. 앱내 화폐에 대한 적립,
            사용, 유효기간 등 관련 정책은 회사 사정에 의해 변경될 수 있습니다.
            제 16조 (경품지급) 회사가 회원에게 경품을 지급할 경우 이용자는
            경품의 추첨일로부터 3개월 이내에 회사에 경품 지급을 요청할 수
            있습니다. 단, 경품 추첨 및 경품지급과 관련하여 회사가 별도의 통지
            또는 공지를 하는 경우에는 그에 따릅니다. 제 17조 (협력사와의 관계)
            회원은 협력사의 재화 등을 광고하는 활동에 참여할 수 있으며, 이는
            회원과 협력사 간의 직접 계약에 의한 것으로 회사는 이에 관여하거나
            분쟁 해결에 대한 책임을 지지 않습니다. 제 18조 (서비스 양도 제한)
            회원은 서비스의 이용 권한, 기타 서비스 이용 계약상의 지위를 타인에게
            양도, 증여할 수 없으며 이를 담보로 제공할 수 없습니다. 다만, 회사의
            서비스는 사업상 기타 운영상의 이유 등으로 양도될 수 있습니다. 제
            19조 (컨텐츠 생성 가이드 및 관리/제한 행위) 1. 회원은 수시로 갱신될
            수 있는 회사의 커뮤니티 가이드라인을 준수하는 데에 동의합니다. 2.
            컨텐츠는 다음의 가이드에 따라 생성될 것을 지향 합니다. ① 컬러 분석을
            원하는 다양한 이미지 등록 ②퍼스널컬러 정보 등록 ③ 회원 특징 정보
            등록 ④ 기타 정보 등록 3. 회원의 컨텐츠가 정보통신망법 및 지식재산권
            등 기타 법에 위반되는 내용을 포함하는 경우, 컨텐츠의 권리자 등은
            관련법이 정한 절차에 따라 해당 컨텐츠의 게시중단 및 삭제 등을
            회사에게 요청할 수 있으며 회사는 해당 사실을 회원에게 통지합니다. 4.
            회사는 전항에 따라 이의가 제기된 컨텐츠가 본 약관 또는 관계 법령에
            위반된다고 판단되는 경우 회원에게 통지함과 동시에 컨텐츠의 게시
            보류, 임시 삭제 등의 조치를 취할 수 있습니다. 5. 회사는 본 조에 따라
            컨테츠 등에 대한 이의제기, 분쟁 발생으로 회원의 이용정지, 컨텐츠
            등의 삭제 등이 발생한 경우 회원에게 통보 합니다. 6. 회사는 서비스
            종료, 운영 상의 이유가 발생한 경우, 서비스 종료 사실을 통보한 뒤
            별도의 보관 없이 컨텐츠 등을 삭제할 수 있습니다. 7. 본 약관에
            명시적으로 규정된 경우를 제외하고, 회사는 콘텐츠 사용에 대한
            명시적이거나 묵시적인 권리를 부여하지 않습니다. 8. 회원은 본
            약관에서 명시적으로 기술된 경우를 제외하고 콘텐츠, 서비스 또는 관련
            소프트웨어의 전부 또는 일부를 복제, 재현, 전재, 프레임 삽입,
            다운로드, 전송, 변경, 전시, 역설계, 매도, 매도 참여, 대여, 임대,
            대출, 양도, 배포, 허가, 재허가하거나 어떠한 방식으로든 활용하지 않는
            데에 동의합니다. 제 20조 (지식재산권의 귀속 및 이용제한) 1. 회사가
            작성한 저작물에 대한 저작권 기타 지식재산권은 회사에 귀속합니다. 2.
            서비스 이용자는 회사 및 서비스를 통하여 얻은 정보 중 회사에게
            지식재산권이 귀속된 정보를 회사의 사전 승낙 없이 복제, 송신, 출판,
            배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게
            이용하게 하여서는 안됩니다. 3. 회사는 회원이 작성한 컨텐츠 등과 재화
            등에 관련된 모든 컨텐츠 등은 회사가 무상으로 직접 이용하거나 회사와
            별도 계약이 체결된 제휴사로 하여금 이용하게 할 수 있고, 회원은 이를
            허락합니다. 제 21조 (분쟁해결) 1. 회사는 서비스 이용자가 제기하는
            정당한 의견이나 불만을 반영하고 피해가 발생한 경우, 그 피해를
            보상처리하기 위하여 피해보상처리기구를 설치·운영합니다. 2. 회사는
            서비스 이용자로부터 제출되는 불만사항 및 의견을 우선적으로
            처리합니다. 다만, 신속한 처리가 곤란한 경우에는 서비스 이용자에게 그
            사유와 처리일정을 즉시 통보해 드립니다. 제 22조 (재판권 및 준거법)
            1. 회사와 이용자 간에 발생한 전자상거래 분쟁에 관한 소송은 제소
            당시의 이용자의 주소에 의하고, 주소가 없는 경우에는 거소를 관할하는
            지방법원의 전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는
            거소가 분명하지 않거나 외국 거주자의 경우에는 민사소송법상의
            관할법원에 제기합니다. 2. 회사와 이용자간에 제기된 전자상거래
            소송에는 한국법을 적용합니다. 부칙. 이 약관은 2025년 5월 08일부터
            적용됩니다. 담당자 연락처: ask@ocollor.com
          </Typography>
        ) : props.language == 2 ? (
          <Typography variant="body1">
            Terms of Use Effective May 8, 2025 Article 1 (Purpose) 1. These
            Terms of Use are intended to stipulate the rights, obligations,
            responsibilities, and other necessary matters between the Company
            and its members in relation to the use of the Ocollor Consulting
            Program service provided by Ocollor Co., Ltd. (hereinafter referred
            to as the “Company”). 2. The Member agrees to be subject to the laws
            of the Republic of Korea in relation to the use of this Service. 3.
            The Company’s Personal Information Processing Policy, which governs
            the Company’s collection and use of information, applies to all
            information provided to the Company. By using the Service, the
            Member agrees to the Company’s collection and use of information (as
            described in the Personal Information Processing Policy), including
            the transmission of such information for storage, processing, and
            use in the Republic of Korea and/or other countries. As part of the
            provision of the Service, the Company may send certain
            communications, such as service announcements and management
            messages, and such communications are considered part of the Service
            and the Member’s Service Account, and the Member cannot refuse to
            receive them. Article 2 (Definitions) The definitions of terms used
            in these Terms of Use are as follows. The interpretation of
            undefined terms shall be governed by the relevant laws and
            service-specific guidelines. Matters not stipulated in the relevant
            laws and service-specific guidelines shall follow general practices.
            1. "Service" means the Ocollor Consulting Program and Ocollor
            Consulting Program-related basic services that "members" can use
            regardless of the installed terminal (including various wired and
            wireless devices such as portable terminals, PCs, and TVs). 2.
            "User" means a person who uses the services provided by the company
            without registering as a member (non-member). 3. "Member" means a
            person who agrees to these Terms and Conditions and uses the
            services provided by the company. 4. "Service User" means a user and
            member. 5. "Content" means various digital information provided by
            members or Ocollor. Article 3 (Specification, explanation, and
            revision of Terms and Conditions, etc.) 1. The Company shall post
            the contents of these Terms and Conditions on the Company so that
            they can be easily understood by service users or notify members by
            other means, thereby making them effective. 2. The Company may
            revise these Terms and Conditions to the extent that it does not
            violate related laws such as the Act on Regulation of Terms and
            Conditions, the Act on Promotion of Information and Communications
            Network Utilization and Information Protection, etc., the Act on
            Consumer Protection in Electronic Commerce, etc., and the Consumer
            Protection Basic Act. 3. When the Company revises the Terms and
            Conditions, it shall notify the member of the revised Terms and
            Conditions along with the current Terms and Conditions in accordance
            with the method of Paragraph 1 from 30 days prior to the date of
            application of the revised Terms and Conditions until the date of
            application. However, in the case of a change in important
            provisions regarding the rights or obligations of members, it shall
            notify the member at least 30 days in advance and send the revised
            Terms and Conditions to the member’s registered email address. 4. If
            the Company notifies or informs the member of the revised Terms and
            Conditions in accordance with the preceding paragraph that failure
            to express intent to reject by the date of application of the change
            in Terms and Conditions will constitute an expression of intent, the
            member shall be deemed to have agreed to the revised Terms and
            Conditions if the member does not express intent to reject. 5. If
            the member does not agree to the revised Terms and Conditions, the
            Company cannot apply the contents of the revised Terms and
            Conditions, and in this case, the member may discontinue use of the
            Service and terminate the User Agreement. 6. Agreeing to these Terms
            means that you agree to regularly check for changes to the Terms and
            Conditions and operating policies through the company and mobile
            application. Members must exercise due care regarding changes to the
            Terms and Conditions, and the company is not responsible for any
            damages suffered by members due to ignorance of changed Terms and
            Conditions. Article 4 (Personal Information Protection) 1. When
            collecting personal information of users, the company collects the
            minimum amount of personal information necessary to provide the
            service. 2. The company does not collect information necessary for
            service operation in advance when registering as a member. However,
            this does not apply in cases where identity verification is required
            to fulfill obligations under relevant laws and regulations and the
            minimum amount of specific personal information is collected. 3.
            When collecting and using personal information of service users, the
            company notifies users of the purpose and scope of the information
            in advance and obtains their consent. 4. The company cannot use the
            collected personal information for purposes other than service
            operation and research purposes, and when a new purpose of use
            arises or when providing it to a third party, the company notifies
            the user of the purpose and obtains their consent at the time of use
            or provision. However, exceptions may apply if the relevant laws and
            regulations provide otherwise. 5. In cases where the company must
            obtain the consent of the service user pursuant to Paragraphs 2 and
            3, the identity of the personal information manager (affiliation,
            name, phone number, and other contact information), the purpose of
            collecting and using information, matters related to the provision
            of information to third parties (recipient, purpose of provision,
            and content of information to be provided), etc., as stipulated in
            the Personal Information Protection Act and the Act on Promotion of
            Information and Communications Network Utilization and Information
            Protection, etc., must be specified or notified in advance, and the
            user may withdraw this consent at any time. 6. The service user may
            request to view or correct errors in his or her personal information
            held by the company at any time, and the company has an obligation
            to take necessary measures without delay. If the service user
            requests correction of errors, the company shall not use the
            personal information in question until the errors are corrected. 7.
            In order to protect personal information, the company shall limit to
            the minimum the number of persons handling the personal information
            of the service user, and shall be fully responsible for any damage
            suffered by the service user due to the loss, theft, leakage,
            provision to a third party without consent, or alteration of the
            personal information of the service user. 8. The Company or a third
            party that has received personal information from the Company shall
            destroy the personal information without delay when the purpose of
            collecting or providing the personal information has been achieved.
            9. The Company shall not set the consent box for the collection,
            use, and provision of personal information as pre-selected. In
            addition, the Company shall specifically state the services that
            will be restricted if the service user refuses to consent to the
            collection, use, and provision of personal information, and shall
            not restrict or refuse the provision of services such as membership
            registration due to the refusal to consent to the collection, use,
            and provision of personal information that is not a required
            collection item. 10. The Member agrees that any feedback,
            suggestions, ideas, or other information or materials that the
            Member provides to the Company by email or other means regarding the
            Company or the Service are not confidential information and are the
            sole property of the Company. The Company shall have the right to
            unrestrictedly use or disseminate such materials and information for
            any purpose, commercial or not, without notice or compensation to
            the Member. The Member agrees not to waive or assert any rights
            (including copyright or moral rights) that the Member may have
            regarding the various information and materials provided to the
            Company. The Company welcomes the opinions of users, but if you want
            compensation or want to maintain ownership or claims regarding such
            ideas, please do not share them with the Company. Article 5
            (Membership Registration) 1. Users apply for membership using the
            following methods. However, the Company may determine separate
            membership application methods depending on the type of media and
            service it operates. ① Method of entering membership information in
            the registration form determined by the Company and expressing
            consent to these Terms and Conditions ② Other methods determined by
            the Company 2. The Company will register as a member users who have
            applied for membership in accordance with Paragraph 1, unless they
            fall under any of the following: ① If the applicant has previously
            lost membership qualifications according to Article 7 of these Terms
            and Conditions. However, this does not apply if the Company has
            approved re-registration as a member. ② If there are any false,
            omitted, or incorrect entries in the registration. ③ If it is
            determined that registering as a member significantly hinders the
            Company’s technology. 3. The time of membership registration is when
            the Company’s approval reaches the member. 4. If there is a change
            in the registration information, the member must notify the company
            of the change within a reasonable period of time by modifying the
            member information. Article 6 (Withdrawal of membership and loss of
            qualification) 1. A member may request withdrawal from the company
            at any time, and the company will immediately process the
            withdrawal. However, all benefits of membership, such as personal
            content and information, that the member had will be canceled upon
            withdrawal. 2. If the member has paid a usage fee for the service or
            in relation to it prior to withdrawal, such usage fee will be
            refunded in accordance with the relevant laws and regulations.
            However, if the member cancels without requesting a refund, it may
            be difficult to refund due to the deletion of related records, etc.,
            so we ask that you complete all necessary refund procedures prior to
            cancellation. In addition, payment obligations that have already
            occurred will not be exempted even if the account is cancelled. 3.
            If the service is canceled or suspended, the company will make
            reasonable efforts to notify the member and provide an opportunity
            to retrieve the content. 4. Upon withdrawal of membership, the
            member information will be destroyed without delay. However, in the
            following cases, the information will be retained for the period
            specified for the retention reasons below. ① Reasons for retaining
            information based on relevant laws and regulations a. National Tax
            Basic Act, Consumer Protection Act, etc. ② Reasons for retaining
            information based on the company's internal policy a. Items to be
            retained: Collected member information such as phone number, date of
            birth, gender, email, and photos b. Reason for retention: Prevention
            of fraudulent registration and use Fraudulent registration: Using
            another person's name to sign up or registering multiple fake
            members for the purpose of participating in events c. In case of
            registration under another person's name Fraudulent use: Using
            another person's name or registering as a fake member for fraudulent
            purposes (such as participating in events) and posting abusive
            language or company promotional content on contents, Q&A, etc. d.
            Retention period: 1 month 5. If a member falls under any of the
            following reasons, the company may restrict or suspend membership. ①
            If false information is registered or another person's information
            is stolen when applying for membership. ② If another person
            threatens the order of e-commerce by interfering with the use of the
            company or stealing such information. ③ If an act prohibited by laws
            or these terms and conditions or against public order and morals is
            committed using the company. ④ If an act falling under any of the
            following items interferes with the company's sound management and
            service operation a. b. When the reputation of the company is
            damaged by spreading groundless false information about the company.
            c. When the company's business operations are hindered by insulting,
            verbally abusing, threatening, sexually harassing, etc. the
            company's employees. d. When excessive compensation exceeding the
            consumer dispute resolution standards notified by the Consumer
            Agency is habitually requested. If the content posted by a member
            falls under any of the following: 1) If it infringes upon the
            rights, honor, credit, or other legitimate interests of others; 2)
            If it is related to a criminal act or violates public order and
            social morals; 3) If it posts, advertises, or links to sites of
            illegal materials, pornography, or media harmful to youth; 4) If it
            is not related to the products and services provided by the company;
            5) If it includes malicious code or data that may cause information
            and communication devices to malfunction; 6) If it is false
            information; 7) If it is content created with benefits from a
            partner company but is not marked as "advertisement" or
            "sponsorship" in accordance with the operating policy provided by
            the company; 8) If it violates other terms of use, various operating
            policies provided by the company, or related laws and regulations.
            Members may have their account access and use suspended upon reports
            from other members or at the company's discretion. The time of
            suspension and whether or not it can be reused will be separately
            notified to members. 7. If the same act is repeated more than twice
            after the company restricts or suspends membership, or if the reason
            is not corrected within 30 days, the company may terminate the
            membership. If the company terminates membership, the membership
            registration will be canceled. In this case, the member will be
            notified and given at least 30 days to explain before the
            cancellation of the membership registration. Article 7 (Notice to
            Members) 1. If the company notifies a member, it may do so through
            the SNS account, e-mail address, or mobile phone number (SMS,
            KakaoTalk account) that the member has agreed upon with the company
            in advance. 2. In the case of notice to an unspecified number of
            service users, the company may replace individual notice by posting
            on the service screen or the company bulletin board for more than
            one week. However, individual notice will be given for matters that
            have a significant impact on the member's own transactions. Article
            8 (Provision and Change of Services) 1. The company provides the
            following service tasks. ① Provision of color analysis service ②
            Advertising service business ③ Other tasks determined by the company
            2. The company only provides information on goods, etc. so that
            users of the service and partners can trade goods, etc., and the
            company bears no responsibility whatsoever for the information on
            goods, etc. provided by partners and all sales activities. Article 9
            (Service Interruption) 1. The company may temporarily suspend the
            provision of services in the event of maintenance, inspection,
            replacement, malfunction, or interruption of communication of
            information and communication equipment. 2. The company shall
            compensate for damages suffered by users or third parties due to the
            temporary suspension of service provision for the reasons in
            Paragraph 1. However, this shall not apply if the company proves
            that there was no intent or negligence. 3. In the event that the
            service cannot be provided due to reasons such as change of business
            type, abandonment of business, or integration between companies, the
            company shall notify the member in the manner specified in Article
            8. Article 10 (Company's Obligations) 1. The company shall not
            engage in any acts prohibited by laws and regulations or these Terms
            and Conditions or contrary to public order and morals, and shall do
            its best to provide services continuously and stably in accordance
            with these Terms and Conditions. 2. The company must have a security
            system to protect the personal information of users so that users
            can safely use the company's services. 3. The company must process
            opinions or complaints raised by members regarding the use of the
            service if it deems them justified. 4. The company will use the
            bulletin board or other methods deemed appropriate by the company to
            communicate the processing process and results to members regarding
            opinions or complaints filed by members. Article 11 (Member’s
            Obligations Regarding ID and Password) 1. Members are responsible
            for managing their ID and password. 2. Members must not allow third
            parties to use their ID and password. 3. If a member becomes aware
            that his or her ID and password has been stolen or is being used by
            a third party, he or she must immediately notify the company and
            follow the company’s instructions, if any. Article 12 (Obligations
            of Service Users) 1. Service users must not commit the following
            acts: ① Registering false information when applying or changing ②
            Stealing other people’s information ③ Disclosing or posting obscene
            or violent messages, images, or other information that goes against
            public order and morals to the company ④ Changing information posted
            on the company ⑤ Infringement on the intellectual property rights of
            the company and other third parties ⑥ Illegal acts that violate
            other laws and these Terms of Use 2. The company is not responsible
            for the results arising from a service user’s violation of the
            obligations of this article. In addition, if damage occurs to the
            company, the service user is liable for damages to the company, and
            the company may suspend the member's use of the service and claim
            damages, etc. through legal procedures. Article 13 (Member's
            Responsibilities) 1. Members use and create this service and various
            contents provided in this service at their own risk, and members are
            responsible for all actions taken through this service and their
            results. 2. Members understand that others may view the contents
            created by members, and that access to the contents may be
            restricted by adjusting the privacy settings. 3. Members are fully
            responsible for their user contents and any claims arising
            therefrom, and agree that the company is not responsible or legally
            liable for any user contents or any claims arising therefrom. 4. The
            company has the right and complete discretion to review, confirm,
            and delete user contents at any time and for any reason, but does
            not have any obligation to do so. 5. Members retain all ownership of
            their user contents. However, by submitting User Content to the
            Company, the Member grants the Company an irrevocable,
            non-exclusive, worldwide, perpetual, royalty-free, sublicensable and
            transferable license to use, reproduce, modify, adapt, edit,
            publish, create derivative works from, distribute, perform, promote,
            exhibit and display such User Content in any and all media or
            distribution methods, including those now known or later developed.
            6. The Member acknowledges and agrees that by accessing or using the
            Service, the Member may be exposed to materials of others that may
            be considered offensive, indecent or otherwise objectionable, and
            agrees to assume such risk. The views expressed through the
            Company’s website or Service do not necessarily represent the views
            of the Company. The Company does not endorse or support any specific
            content posted by members or users of the Service. 7. The Company
            will provide possible security measures to protect the Content, but
            shall not be liable for any damage resulting from the disclosure of
            the Content. 8. If the Member engages in any of the following acts,
            the Member shall resolve the related dispute at his/her own
            responsibility and expense, and the Company shall not be liable for
            such. ① If you upload or reproduce content that is false,
            misleading, or violates public order and morals ② If the uploaded
            content, etc. defames another person or invades their privacy ③ If
            you share or distribute a third party's photos or videos on the
            company or electronic communication network, etc. ④ If the member's
            actions violate another person's intellectual property rights,
            related laws, or these Terms and Conditions ⑤ If you infringe on
            another person's rights for any other reason Article 14 (Member
            Level) The company may set member levels based on the activities of
            members using the service, and may differentiate service use and
            benefit payments based on level. Article 15 (In-App Currency System)
            1. In-app currency is generated during the use of services operated
            by the company, and the validity period, amount, etc. are applied
            differently depending on individual activity. 2. In-app currency is
            not a liquid asset of the customer and therefore cannot be converted
            into cash. If it is discovered that it was accumulated through
            fraudulent activities, it may be converted or cancelled. 3. In-app
            currency will automatically expire after the specified period of
            time. Purchased in-app currency cannot be converted back to cash. 4.
            In-app currency will be canceled and cannot be restored when a
            member withdraws or loses qualification. 5. The policies related to
            the accumulation, use, and validity period of in-app currency may be
            changed according to the company's circumstances. Article 16 (Prize
            Payment) If the company pays a prize to a member, the user may
            request the company to pay the prize within 3 months from the prize
            drawing date. However, if the company makes a separate notice or
            announcement regarding the prize drawing and prize payment, such
            notice shall be followed. Article 17 (Relationship with Partners)
            Members may participate in activities advertising the products of
            the partner company, etc., and this is based on a direct contract
            between the member and the partner company, and the company is not
            involved in this or responsible for resolving disputes. Article 18
            (Restrictions on Transfer of Services) Members may not transfer or
            donate the right to use the service or other status under the
            service use agreement to others, and may not provide this as
            collateral. However, the company's services may be transferred for
            business or other operational reasons. Article 19 (Content Creation
            Guidelines and Management/Restrictions) 1. Members agree to comply
            with the Company's community guidelines, which may be updated from
            time to time. 2. Contents are intended to be created in accordance
            with the following guidelines: ① Registering various images for
            color analysis ② Registering personal color information ③
            Registering member characteristic information ④ Registering other
            information 3. If a member's content includes content that violates
            the Information and Communications Network Act, intellectual
            property rights, or other laws, the rights holder of the content may
            request the Company to suspend or delete the content in accordance
            with the procedures set forth in the relevant laws, and the Company
            will notify the member of such fact. 4. If the Company determines
            that the content objected to in accordance with the preceding
            paragraph violates these Terms and Conditions or relevant laws, it
            may notify the member and take measures such as suspending or
            temporarily deleting the content. 5. If an objection is raised
            regarding the content, etc., or a dispute arises, resulting in the
            suspension of a member's use or deletion of the content, etc. in
            accordance with this Article, the Company will notify the member. 6.
            If the Company terminates the service or there is an operational
            reason, the Company may delete the content, etc. without separate
            storage after notifying the member of the termination of the
            service. 7. Except as expressly provided for in these Terms and
            Conditions, the Company does not grant any express or implicit
            rights to use the Content. 8. Except as expressly provided for in
            these Terms and Conditions, the Member agrees not to copy,
            reproduce, reprint, insert frames, download, transmit, modify,
            display, reverse engineer, sell, participate in the sale, rent,
            lease, loan, assign, distribute, license, sublicense, or use in any
            way all or part of the Content, Services, or related software.
            Article 20 (Attribution of Intellectual Property Rights and
            Restrictions on Use) 1. The copyright and other intellectual
            property rights for works created by the Company belong to the
            Company. 2. Service users may not use for profit or allow third
            parties to use for profit information obtained through the Company
            and Services, including information to which the Company holds
            intellectual property rights, by copying, transmitting, publishing,
            distributing, broadcasting, or other methods, without the Company’s
            prior consent. 3. The Company may use all content, etc. related to
            goods, etc. created by members directly free of charge or allow
            affiliates that have entered into a separate contract with the
            Company to use such information, and the Member hereby consents to
            this. Article 21 (Dispute Resolution) 1. The Company shall establish
            and operate a damage compensation processing organization to reflect
            the legitimate opinions or complaints raised by service users and,
            in the event of damage, to compensate for the damage. 2. The Company
            shall give priority to complaints and opinions submitted by service
            users. However, in cases where prompt processing is difficult, the
            Company shall immediately notify the service user of the reason and
            processing schedule. Article 22 (Jurisdiction and Governing Law) 1.
            Litigation regarding e-commerce disputes between the Company and
            users shall be under the exclusive jurisdiction of the local court
            with jurisdiction over the user's address at the time of filing the
            lawsuit, or, if there is no address, the place of residence.
            However, if the user's address or residence is unclear at the time
            of filing the lawsuit or if the user is a foreign resident, the
            lawsuit shall be filed with the court with jurisdiction under the
            Civil Procedure Act. 2. Korean law shall apply to e-commerce
            lawsuits filed between the Company and users. Supplementary
            Provisions. These Terms and Conditions shall be effective from May
            8, 2025. Contact Person: ask@ocollor.com
          </Typography>
        ) : props.language == 3 ? (
          <Typography variant="body1">
            利用約款 2025年05月08日施行第1条（目的） 1.
            この約款は、株式会社オコロール（以下「会社」）が提供するオコロールコンサルティングプログラムサービスの利用に関する会社と会員との権利、義務および責任事項、その他必要な事項を規定することを目的としています。
            2.会員は、本サービスの利用に関連して大韓民国法の適用を受けることに同意します。
            3.会員は、会社に提供する情報一体に対して会社の情報収集及び利用を規律する会社の個人情報処理方針が適用されます。会員は、サービスを利用することにより、当該情報の大韓民国及び/又はその他の国内保管、処理及び利用のための転送を含め、(個人情報処理方針に記載されている通り)会社の情報収集及び利用に同意します。サービス提供の一環として、当社はサービス通知および管理メッセージなどの特定のコミュニケーションを送信することができ、そのようなコミュニケーションはサービスおよび会員のサービスアカウントの一部と見なされ、その受信を拒否することはできません。第2条（定義）本規約で使用する用語の定義は次のとおりです。定義されていない用語の解釈は、関係法令およびサービス固有のガイダンスに定められています。関係法令とサービス別案内で定めないものは一般的な相関例に従います。
            1.
            「サービス」とは、設置されている端末（携帯型端末、PC、TVなどの各種有無線機器を含む）に関係なく、「会員」が利用できるオコロールコンサルティングプログラムおよびオコロールコンサルティングプログラム関連基盤サービスを意味します。
            2.
            利用者とは会員登録をせず（非会員）会社が提供するサービスを利用する者をいいます。
            3.
            「会員」とは、本規約に同意し、当社が提供するサービスを利用する者をいいます。
            4. 「サービス利用者」とは、利用者及び会員をいいます。 5.
            「コンテンツ」とは、会員またはオコロールで提供される各種のデジタル情報をいう。第3条（約款等の明示と説明及び改正）
            1.会社は、この約款の内容をサービス利用者が容易に知ることができるように会社に掲示したり、その他の方法で会員に公知することにより効力が発生します。
            2.
            会社は、約款の規制に関する法律、情報通信網利用促進及び情報保護等に関する法律、電子商取引等での消費者保護に関する法律、消費者基本法等関連法を違反しない範囲でこの約款を改正することができます。
            3.
            会社が約款を改正する場合には、適用日時及び改正理由を明示し、現行約款とともに第1項の方法により改正約款の適用日の30日前から適用日前まで公知します。ただし、会員の権利又は義務に関する重要な規定の変更の場合には、少なくとも30日前に公知し、改正約款を会員が登録したEメールで発送して通知します。
            4.
            会社が前項により改正約款を公知又は通知し、約款変更適用日まで拒否医師を表示しない場合、意思表示が表明されるという内容を知らせたにもかかわらず、会員が明示的に拒否医師を表示しない場合、会員が改正約款に同意したものとみなします。
            5.
            会員が変更された約款に同意しない場合、会社は改正約款の内容を適用することができず、この場合、会員はサービスの利用を中断して利用契約を解除することができます。
            6.
            本規約に同意することは、定期的に会社及びモバイルアプリケーションを通じて規約の変更事項及び運営方針等を確認することに同意することを意味します。会員は約款の変更について注意義務を果たさなければならず、変更された約款の敷地による会員の被害は会社が責任を負いません。第4条（個人情報保護）1.会社は、利用者の個人情報収集時にサービス提供のために必要な範囲で最小限の個人情報を収集します。
            2.会社は会員登録時にサービス運営に必要な情報を事前に収集しません。ただし、関連法令上の義務履行のために本人確認が必要な場合として、最小限の特定個人情報を収集する場合には、この限りではありません。
            3.
            会社はサービス利用者の個人情報を収集・利用する際、事前にその目的と範囲等の法令上の内容を告知して同意を受けます。
            4.
            会社は収集された個人情報をサービス運営及び研究目的以外の用途で利用することができず、新たな利用目的が発生した場合又は第三者に提供する場合には、利用・提供段階で当該利用者にその目的を告知し同意を受けます。ただし、関連法令に別段の定めがある場合には例外とします。
            5.
            会社が第2項及び第3項によりサービス利用者の同意を受けなければならない場合には、個人情報管理責任者の身元(所属、氏名及び電話番号、その他連絡先)、情報の収集目的及び利用目的、第3者に対する情報提供関連事項(提供された者、提供目的及び提供する情報の内容)等「個人情報保護「法律」が規定する事項を事前に明示または告知しなければならず、利用者はいつでもこの同意を撤回することができます。
            6.
            サービス利用者はいつでも会社が持っている自分の個人情報に対して閲覧及びエラー訂正を要求することができ、会社はこれに対して遅滞なく必要な措置を取る義務を負います。サービス利用者がエラーの訂正を要求した場合には、会社はそのエラーを訂正するまで当該個人情報を利用しません。
            7.
            会社は個人情報保護のためにサービス利用者の個人情報を取り扱う者を最小限に制限しなければならず、サービス利用者の個人情報の紛失、盗難、流出、同意のない第三者提供、改ざん等によるサービス利用者の損害に対してすべての責任を負います。
            8.
            会社又はそれから個人情報を提供された第三者は、個人情報の収集目的又は提供された目的を達成したときは、当該個人情報を遅滞なく破棄します。
            9.
            会社は個人情報の収集・利用・提供に関する同意欄をあらかじめ選択したものに設定しておきません。また、個人情報の収集・利用・提供に関するサービス利用者の同意拒絶時に制限されるサービスを具体的に明示し、必須収集項目ではなく個人情報の収集・利用・提供に関する同意拒絶を理由に会員登録等サービス提供を制限したり拒否しません。
            10.会員が会社またはサービスに関してEメールまたはその他の方法で会社に提供するフィードバック、提案、アイデア、その他の情報や資料などは、秘密情報ではなく、会社の固有の財産であることに同意します。当社は、会員に通知や補償を提供することなく、商業性の有無を問わず、いかなる目的であっても、そのような資料および情報を無制限に利用または伝播する権利を保有します。会員は、会員が当社に提供した様々な情報および資料に関して持つ権利（著作権または著作人格権を含む）の一切を放棄したり、会社に主張しないことに同意します。会社はユーザーの意見を歓迎しますが、報酬を希望する場合、またはそれに関する所有権または請求権を継続的に保持したい場合は、会社とアイデアを共有しないでください。第5条（会員登録）1.利用者は、次の各号の方法で会員登録を申請します。ただし、会社は運営する媒体及びサービスの種類に応じて別途の会員登録申請方法を定めることができます。
            ①会社が定めた加入様式により会員情報を記入した後、本約款に同意するという意思表示をする方法
            ②その他会社で定める方法 2.
            会社は、第1項のように会員として加入することを申請した利用者のうち、次の各号に該当しない限り会員として登録します。
            ①加入申請者がこの約款第7条により以前に会員資格を喪失したことがある場合。ただし、会社の会員再加入承諾を得た場合には例外とします。
            ②登録内容に虚偽、記載漏れ、誤記がある場合
            ③その他会員として登録することが会社の技術上著しく支障があると判断される場合
            3.会員登録の成立時期は会社の承諾が会員に到達した時点とします。会員は登録事項に変更がある場合、相当な期間内に会社に対して会員情報修正等の方法でその変更事項を知らせなければなりません。第6条（会員脱退及び資格喪失）
            1.会員は、会社にいつでも脱退を要請することができ、会社は直ちに会員脱退を処理します。ただし、会員脱退時に会員が保有していた個人的なコンテンツ、情報など会員としてのすべての特典は消滅します。
            2.
            退会前に会員がサービスのため又はこれに関連して支払った使用料がある場合、そのような使用料は関連法令で定めた内容により返金されます。ただし、払い戻しを請求せずに解約する場合、関連記録の削除等により払い戻しに困難が生じる場合がありますので、解約前に必要な払い戻し手続きをすべて履行していただきますようお願いいたします。また、アカウントの終了時にもすでに発生した支払義務は免除されません。
            3.サービスが終了または中止された場合、当社はこれを通知し、コンテンツの回収の機会を提供するために合理的な努力をします。
            4.
            会員脱退時、会員情報は遅滞なく破棄します。ただし、次の事由の場合には、下記の保存理由のために明示した期間の間保存します。
            ①関係法令に基づく情報保有事由 ア．国税基本法、消費者基本法等
            ②会社内部方針に基づく情報保有事由
            ア．保存項目：電話番号、生年月日、性別、Eメール、写真など収集会員情報保存理由：不正加入と利用防止
            不正加入：他人の名義を盗んで加入したり、イベント応募を目的とした多数の苛性会員。名義で加入する場合
            不正利用：名義盗用、苛性会員加入で不正な目的の取引行為（イベント応募等）をする場合と、コンテンツ等及びQ&A等に誓い、業者広報文を掲示する場合。保存期間：1ヶ月5.会員が次の各号の理由に該当する場合、会社は会員資格を制限および停止することができます。
            ①加入申請時に虚偽内容を登録したり、他人を情報を盗用した場合
            ②他の人の会社利用を妨害したり、その情報を盗用するなど電子商取引秩序を脅かす場合
            ③会社を利用して法令又はこの約款が禁止したり公序良俗に反する行為をする場合
            ④次の各木に該当する行為を運営する行く。会社に対する根拠のない虚偽の事実を流布して会社の名誉を失墜させる場合会社の職員に対する侮辱、暴言、脅迫、セクハラなどで会社の業務運営を妨げる場合。消費者源が告示した消費者紛争解決基準を超える過度な補償を常習的に要請する場合。会員が掲載するコンテンツ等が次の各号に該当する場合
            1)他人の権利や名誉、信用等その他正当な利益を侵害する場合内容の場合
            5)情報通信機器の誤動作を引き起こす可能性のあるマルウェアやデータを含む場合
            6)虚偽情報である場合
            7)パートナー社から恩恵を受けた生成されたコンテンツや「広告」、「協賛」など当社が提供した運営政策により表記しない場合
            8)その他本利用規約、当社が提供する各種会員の報告および会社の判断により、アカウントへのアクセスおよびアカウントの使用が停止されることがあります。停止時点と再利用可否は会員に別途通知されます。
            7.
            会社が会員資格を制限及び停止させた後、同じ行為が2回以上繰り返されるか、30日以内にその理由が是正されない場合、会社は会員資格を喪失させることができます。会社が会員資格を喪失させる場合には会員登録を抹消します。この場合、会員にこれを通知し、会員登録抹消の前に少なくとも30日以上の期間を定めて召命する機会を付与します。第7条（会員に対する通知）
            1.会社が会員に対する通知をする場合、会員が会社とあらかじめ約定して指定したSNSアカウント、電子メールアドレス、携帯電話番号(SMS、カカオトークアカウント)にすることができます。
            2.
            会社は不特定多数サービス利用者に対する通知の場合、1週間以上サービス画面または会社内掲示板に掲示することにより個別通知に代えることができます。ただし、会員本人の取引に関連して重大な影響を及ぼす事項については個別通知します。第8条(サービスの提供及び変更)
            1.会社は、次の各号のサービス業務を提供します。 ①
            カラー分析サービス提供 ② 広告サービス業 ③ その他会社が定める業務 2.
            会社はサービス利用者とパートナー社との間で財貨等を取引できるよう財貨等の情報のみを提供し、会社はパートナー社が提供する財貨等の情報及び販売の諸行為に関しては一切の責任を負いません。第9条（サービスの中断）1.会社は、情報通信設備の保守点検・交換及び故障、通信の断絶等の事由が発生した場合には、サービスの提供を一時的に中断することができます。
            2.
            会社は、第1項の事由でサービスの提供が一時的に中断されることにより、利用者又は第三者が被った損害に対して賠償します。ただし、会社が故意または過失がないことを立証する場合は、この限りではありません。事業種目の転換、事業の放棄、事業者間の統合等の理由でサービスを提供できなくなる場合には、会社は第8条に定める方法で会員に通知します。第10条（会社の義務）
            1.会社は、法令とこの約款が禁止したり、公序良俗に反する行為をせず、この約款が定めるところにより、持続的かつ安定的にサービスを提供することに最善を尽くしなければなりません。
            2.会社は、サービス利用者が安全に会社のサービスを利用できるように、利用者の個人情報保護のためのセキュリティシステムを備えなければなりません。
            3.
            会社は、サービス利用に関して会員から提起された意見や不満が正当であると認める場合には、これを処理しなければなりません。
            4.会社は会員が提起した意見や苦情については掲示板を活用したり、他の会社が適当と判断される方法などを通じて会員に処理過程及び結果を伝達します。第11条（会員のID及びパスワードに対する義務）
            1. ID及びパスワードに関する管理責任は会員にあります。 2.
            会員は、自分のID及びパスワードを第三者に利用させてはならない。 3.
            会員が自分のID及びパスワードを盗難されたり、第三者が使用していることを認知した場合には直ちに会社に通知し、会社の案内がある場合にはそれに従わなければなりません。第12条（サービス利用者の義務）
            1. サービス利用者は、次の各号の行為をしてはならない。
            ①申請又は変更時虚偽内容の登録 ②他人の情報盗用
            ③わいせつ又は暴力的なメッセージ、イメージ、その他公序良俗に反する情報を会社に公開又は掲示する行為
            ④会社に掲示された情報の変更
            ⑤会社及びその他第三者の知的財産権等に対する侵害
            ⑥他法令及び本利用約款へ事項に違反して生じた結果について、当社は責任を負いません。また、会社に損害が発生した場合、サービス利用者は会社に対する損害賠償義務を負い、会社は当該会員に対してサービス利用停止及び適法な手続きを経て損害賠償等を請求することができます。第13条（会員の責任）1.会員は、本人の責任の下、本サービス及び本サービスで提供される各種コンテンツ等を利用して生成し、会員は、本サービスを通じてなされた一切の行為及びその結果に対して責任を負います。
            2.会員は、会員が制作したコンテンツを他人が閲覧することができ、個人情報保護設定の調整によりコンテンツへのアクセスを制限できることを理解します。
            3.
            会員は、自身のユーザーコンテンツ及びそれから発生する請求に対して完全な責任を負い、会社は、いかなるユーザーコンテンツ又はそれから発生する請求に対しても責任又は法的責任を負わないことに同意します。
            4.
            当社は、いつでも理由を問わず、ユーザーコンテンツを審査、確認、削除する権利と完全な裁量を保有する一方、それに対する義務を負いません。
            5.会員は、会員のユーザーコンテンツの所有権を一切保持します。しかし、ユーザーコンテンツを会社に提出することにより、会員は未知または将来開発されることを含むすべての媒体または配信方法を利用して、そのようなユーザーコンテンツを利用、再現、変更、脚色、編集、出版、二次著作物の製作、配布、公演、広報、展示および陳列できる、取り消し不可能で非独占的な、世界的、永久的、無償、無償与えます。
            6.会員は、サービスにアクセスすること、またはサービスを利用することによって、侮辱的、卑猥な、またはその他の不愉快であるとみなされる他人の資料にさらされる可能性があることを認め、これに同意し、そのような危険を冒すことに同意します。会社のウェブサイトまたはサービスを通じて表現される見解は、必ずしも会社の見解を表すものではありません。会社は、会員またはサービス利用者が投稿した特定のコンテンツを承認または支持しません。
            7.会社はコンテンツ保護のために可能なセキュリティ対策を提供しますが、コンテンツの開示に起因する損害に対する責任を負いません。
            8.会員は、次の各号の行為をした場合、自身の責任と費用で関連紛争を解決し、これに関して会社は責任を負いません。
            ①虚偽・偽情報・公共秩序及び迷風養属に違反するコンテンツ等をアップロード・再生産等をする場合
            ②アップロードされたコンテンツ等が他人の名誉を毀損したり、私生活を侵害する場合
            ③会社又は電子通信網等において第三者の写真及び映像物等を共有又は流布した場合
            ④、会員約款に違反する行為の場合
            ⑤その他の事由により他人の権利を侵害した場合 第14条（会員等級）
            会社は、サービスを利用する会員の活動に応じて会員等級を設定することができ、等級に応じてサービス利用及び特典支給に差等を置くことができる。第15条（アプリ内貨幣制度）
            1.アプリ内貨幣は、会社が運営するサービス利用過程で発生し、個々の活動により有効期間、金額等が異なって適用されます。
            2.
            アプリ内通貨はお客様の還元性資産ではないため現金に還元されず、不正行為による積立発見時に還元及び消滅措置されることがあります。
            3.
            アプリ内通貨は、指定された期間が経過すると自動的に消滅します。購入したアプリ内通貨は現金に戻りません。
            4. アプリ内通貨は会員の脱退及び資格喪失時に消滅し、復旧されません。
            5.
            アプリ内貨幣の積立、使用、有効期間など関連ポリシーは会社事情により変更されることがあります。第16条（景品支給）会社が会員に景品を支給する場合、利用者は景品の抽選日から3ヶ月以内に会社に景品支給を要請することができます。但し、景品抽選及び景品支払に関し、会社が別途の通知又はお知らせをする場合にはそれに従います。第17条（協力会社との関係）会員は協力会社の財貨等を宣伝する活動に参加することができ、これは会員と協力会社間の直接契約によるもので、会社はこれに関与したり紛争解決に対する責任を負いません。第18条（サービス譲渡制限）会員は、サービスの利用権限、その他サービス利用契約上の地位を他人に譲渡、贈与することができず、これを担保として提供することはできません。ただし、会社のサービスは、事業上その他運営上の理由などで譲渡されることがあります。第19条（コンテンツ作成ガイドおよび管理/制限行為）1.会員は、随時更新される可能性のある会社のコミュニティガイドラインを遵守することに同意します。
            2. コンテンツは、次のガイドに従って作成されることを目指します。
            ①カラー分析を希望する多様な画像登録②パーソナルカラー情報登録③会員特徴情報登録④その他情報登録4.
            会社は、前項により異議が提起されたコンテンツが本規約又は関係法令に違反すると判断された場合、会員に通知するとともに、コンテンツの公開保留、一時削除等の措置を取ることができます。
            5.
            会社は、本条によりコンテンツ等に対する異議提起、紛争発生で会員の利用停止、コンテンツ等の削除等が発生した場合、会員に通知します。
            6.
            会社はサービス終了、運営上の理由が発生した場合、サービス終了事実を通知した後、別途の保管なしにコンテンツ等を削除することができます。
            7.本規約に明示的に規定されている場合を除き、当社はコンテンツの使用に関する明示的または黙示的な権利を付与しません。
            8.会員は、本規約に明示的に記載されている場合を除き、コンテンツ、サービス、または関連ソフトウェアの全部または一部を複製、再現、転載、フレームの挿入、ダウンロード、転送、変更、展示、逆設計、売り、売り参加、レンタル、リース、貸し出し、譲渡、配布、許可、再許可、またはいかなる方法でも活用しないことに同意します。第20条（知的財産権の帰属及び利用制限）
            1.
            会社が作成した著作物に対する著作権その他の知的財産権は会社に帰属します。
            2.
            サービス利用者は、会社及びサービスを通じて得た情報のうち会社に知的財産権が帰属した情報を会社の事前の承諾なしに複製、送信、出版、配布、放送その他の方法により営利目的に利用したり、第三者に利用させてはならない。
            3.
            会社は会員が作成したコンテンツ等と財等に関連するすべてのコンテンツ等は、会社が無償で直接利用したり、会社と別途契約が締結された提携会社に利用させたり、会員はこれを許諾します。第21条（紛争解決）1.会社は、サービス利用者が提起する正当な意見や不満を反映して被害が発生した場合、その被害を補償処理するために被害補償処理機構を設置・運営します。
            2.
            当社は、サービス利用者から提出される苦情及び意見を優先的に処理します。ただし、迅速な処理が困難な場合には、サービス利用者にその理由と処理日程を直ちに通知します。第22条（裁判権及び準拠法）1.会社と利用者間に発生した電子商取引紛争に関する訴訟は、提訴当時の利用者の住所により、住所がない場合には居所を管轄する地方裁判所の専属管轄とします。ただし、提訴当時利用者の住所又は居所が明らかでない、又は外国居住者の場合には民事訴訟法上の管轄裁判所に提起します。
            2.
            会社と利用者の間に提起された電子商取引訴訟には韓国法を適用します。付則。この規約は2025年5月08日から適用されます。担当者の連絡先：ask@ocollor.com
          </Typography>
        ) : props.language == 4 ? (
          <Typography variant="body1">
            使用条款 自 2025 年 5 月 8 日起生效 第 1 条（目的）
            1.本使用条款旨在规定公司与其会员之间在使用 Ocollor
            有限公司（以下简称“公司”）提供的 Ocollor
            咨询项目服务方面的权利、义务、责任和其他必要事项。
            2.会员同意遵守与使用本服务有关的韩国法律。
            3.公司个人信息处理政策规范了公司信息的收集和使用，适用于向公司提供的所有信息。通过使用本服务，会员同意公司收集和使用信息（如个人信息处理政策中所述），包括将此类信息传输到韩国和/或其他国家以进行存储、处理和使用。作为提供服务的一部分，公司可能会发送某些通信，例如服务公告和管理消息，这些通信被视为服务和会员服务帐户的一部分，会员不能拒绝接收。第2条（定义）本使用条款中使用的术语定义如下。未定义术语的解释应受相关法律和服务特定准则的约束。相关法律和服务特定准则中未规定的事项应遵循一般惯例。1.“服务”是指“会员”无论安装何种终端（包括便携式终端、PC和电视等各种有线和无线设备）均可使用的Okolor咨询计划以及与Okolor咨询计划相关的基础服务。2.“用户”是指未注册为会员（非会员）而使用公司提供的服务的个人。3.“会员”是指同意本条款和条件并使用公司提供的服务的个人。4.“服务用户”是指用户和会员。
            5.“内容”是指会员或Okolor提供的各种数字信息。第3条（条款的具体化、说明及修改等）1.公司应将本条款的内容在公司网站上登载，以便服务用户轻松理解，或通过其他方式通知会员，从而使其生效。2.公司在不违反《条款限制相关法律》、《信息通信网使用促进及信息保护等相关法律》、《电子商务等消费者保护相关法律》、《消费者保护基本法》等相关法律的范围内，可以修改本条款。3.公司修改条款时，应自修改条款适用日前30天起至适用日止，按照第1项规定的方式，将修改后的条款与现行条款一并通知会员。但，若涉及会员权利或义务的重要条款发生变更，公司应至少提前30天通知会员，并将修改后的条款发送至会员注册的邮箱地址。4.公司根据前款规定，将修改后的条款通知或告知会员，会员未在条款变更适用日前表示拒绝即视为同意，会员未表示拒绝的，视为同意修改后的条款。5.会员不同意修改后的条款时，公司无法适用修改后的条款内容，此时会员可以停止使用本服务并解除使用协议。6.同意本条款即表示同意通过公司及移动应用程序定期查看条款及运营政策的变更情况。会员应对条款的变更保持足够的警惕，对于会员因不了解修改后的条款而遭受的损失，公司概不负责。第四条（个人信息保护）
            1.
            公司在收集用户的个人信息时，仅收集提供服务所需的最低限度的个人信息。
            2.
            公司不会在用户注册会员时提前收集运营服务所需的信息。但是，为了履行相关法律法规规定的义务需要进行身份验证，且收集最低限度的特定个人信息的情况下，不在此限。
            3.
            公司在收集和使用服务用户的个人信息时，会提前将信息的使用目的和范围告知用户，并取得其同意。
            4.
            公司不得将收集的个人信息用于运营服务及研究目的以外的目的，当出现新的使用目的或提供给第三方时，会在使用或提供时告知用户其使用目的并取得其同意。但是，相关法律法规另有规定时，可能存在例外情况。
            5.
            公司根据第2款和第3款规定需要取得服务利用者的同意时，必须事先明示或告知个人信息管理者的身份（所属机构、姓名、电话号码等联系方式）、信息收集和使用目的、向第三方提供信息的相关事项（接收者、提供目的、提供信息内容）等，这些都符合《个人信息保护法》和《信息通信网利用促进及信息保护等相关法律》的规定，用户可以随时撤回该同意。6.
            服务利用者可以随时要求阅览或更正公司所持有的个人信息中的错误，公司有义务立即采取必要措施。如果服务利用者要求更正错误，公司在错误更正之前不得使用该个人信息。
            7.
            公司为保护个人信息，将处理服务用户个人信息的人员限制在最低限度，并对因服务用户个人信息丢失、被盗、泄露、未经同意提供给第三方或被篡改而给服务用户造成的任何损害承担全部责任。8.
            公司或从公司获得个人信息的第三方在达到收集或提供个人信息的目的后，应立即销毁个人信息。9.
            公司不得将个人信息的收集、使用和提供的同意框设置为预先选择。此外，公司将具体说明如果服务用户拒绝同意个人信息的收集、使用和提供，将被限制的服务，并且公司不会因为拒绝同意非必要收集项目的个人信息的收集、使用和提供而限制或拒绝提供会员注册等服务。
            10.
            会员同意，会员通过电子邮件或其他方式向公司提供的任何有关公司或本服务的反馈、建议、想法或其他信息或资料均不属于保密信息，且属于公司的唯一财产。公司有权不受限制地将此类资料和信息用于任何目的（无论是否用于商业目的），而无需通知或向会员支付任何报酬。会员同意不放弃或主张其对向公司提供的各种信息和资料可能拥有的任何权利（包括版权或道德权利）。公司欢迎用户提出意见，但如果您希望获得报酬或希望保留对这些想法的所有权或主张，请勿与公司分享。第5条（会员注册）1.
            用户使用以下方法申请会员资格。但公司可能会根据其运营的媒体和服务类型确定单独的会员申请方法。
            ① 在公司规定的注册表中填写会员信息并表示同意本条款的方式 ②
            公司规定的其他方式
            2.公司将根据第1款规定申请加入会员的用户注册为会员，但符合下列情况之一的除外：
            ①
            申请人之前根据本条款第7条规定丧失会员资格的情况。但是，公司允许重新注册会员的情况除外。
            ② 注册时存在虚假、遗漏或不正确内容的情况。 ③
            判断注册会员会严重妨碍公司技术的情况。 3.
            会员注册时间为公司批准到达会员的时间。 4.
            注册信息发生变更时，会员必须在合理的时间内通过修改会员信息的方式通知公司。
            第6条（会员资格的退出和资格的丧失） 1.
            会员可以随时向公司申请退出，公司将立即为其办理退出手续。但是，会员退出时，其拥有的个人内容和信息等所有会员权益都将被取消。
            2.
            如果会员在退出前已经支付了服务或与服务相关的使用费，该使用费将根据相关法律法规退还。但是，如果会员未申请退款就退出，由于相关记录被删除等原因，退款可能会变得困难，因此我们要求您在退出前完成所有必要的退款程序。此外，即使账户被注销，已经发生的付款义务也不会免除。
            3.
            如果服务被取消或暂停，公司将尽合理努力通知会员并提供检索内容的机会。
            4.
            退出会员资格后，会员信息将被立即销毁。但是，在以下情况下，信息将根据以下保留原因保留指定的期限。
            ① 基于相关法律法规的信息保留事由 a. 国税基本法、消费者保护法等 ②
            基于公司内部政策的信息保留事由
            a.保留项目：收集的会员信息，例如电话号码、出生日期、性别、电子邮件和照片
            b.保留原因：防止欺诈注册和使用
            欺诈注册：使用他人名义注册或注册多个虚假会员以参加活动为目的
            c.以他人名义注册的情况
            欺诈使用：使用他人名义或注册为虚假会员以进行欺诈目的（例如参加活动）并在内容、Q&A等上发布辱骂性语言或公司宣传内容
            d.保留期限：1个月
            5.如果会员符合以下任何事由，公司可能会限制或暂停会员资格。 ①
            申请会员资格时注册虚假信息或窃取他人信息的情况。 ②
            其他人干扰公司的使用或窃取此类信息，威胁电子商务秩序的情况。 ③
            利用公司实施法律或本条款禁止的行为或违反公共秩序和道德的行为。 ④
            属于下列各项之一的行为，妨碍公司健全经营和服务运营时 a.
            散布关于公司的毫无根据的虚假信息，损害公司名誉时。 c.
            对公司员工进行侮辱、谩骂、威胁、性骚扰等，妨碍公司业务运营时。 d.
            经常要求超过消费者机构公告的消费者纠纷解决标准的过高赔偿时。
            会员发布的内容属于下列任何一项时：1）侵犯他人权利、名誉、信用或其他合法利益时；2）涉及犯罪行为或违反公共秩序和社会道德时；3）发布、宣传或链接到非法内容、色情或对青少年有害媒体的网站时；4）与公司提供的产品和服务无关时；5）包含可能导致信息和通信设备故障的恶意代码或数据时；
            6) 虚假信息；7)
            使用合作公司利益制作的内容，但未按照公司提供的运营政策标记为“广告”或“赞助”；8)
            违反其他使用条款、公司提供的各项运营政策或相关法律法规。根据其他会员的举报或公司自行判断，会员的账户访问和使用可能会被暂停。暂停时间和是否可以再次使用将另行通知会员。7.
            公司限制或暂停会员资格后，如果重复两次以上相同行为，或30天内未纠正原因，公司可以终止会员资格。如果公司终止会员资格，会员注册将被取消。在这种情况下，将在取消会员注册前通知会员并给予至少30天的时间说明理由。第7条（对会员的通知）
            1.公司通知会员时，可以通过会员事先与公司约定的SNS账号、电子邮件地址、手机号码（短信、KakaoTalk账号）等方式进行。
            2.公司在向不特定多数服务利用者通知的情况下，可以通过在服务画面或公司公告栏上发布一周以上的方式代替个别通知。但是，对会员自身交易有重大影响的事项，将进行个别通知。
            第8条（服务的提供及变更） 1.公司提供以下服务业务。 ①提供色彩分析服务
            ②广告服务业务 ③其他公司规定的业务
            2.公司仅为了让服务利用者和合作公司进行商品等交易而提供商品等信息，对合作公司提供的商品等信息及一切贩卖活动，公司不承担任何责任。第9条（服务中断）
            1.公司因信息通信设备的维护、检查、更换、故障或通信中断等情况，可暂时中止提供服务。
            2.公司因第1款事由暂时中止提供服务，给用户或第三方造成损失的，应当赔偿损失。但是，如果公司能证明没有故意或过失，则不在此限。
            3.公司因变更业务种类、放弃业务、公司间整合等事由无法提供服务时，应按照第8条规定的方式通知会员。
            第10条（公司的义务）
            1.公司不得从事法律法规或本条款禁止的行为或违反公共秩序和道德的行为，并应按照本条款尽力持续稳定地提供服务。
            2.公司必须具备保护用户个人信息的安全系统，以便用户可以安全地使用公司服务。
            3.
            公司对于会员在使用服务过程中提出的意见或投诉，如公司认为合理，必须予以处理。4.公司将通过公告栏或其他公司认为适当的方式，就会员提出的意见或投诉，向会员通报处理过程及结果。第11条（会员关于ID和密码的义务）1.会员有责任管理自己的ID和密码。2.会员不得将自己的ID和密码提供给第三方使用。3.如果会员发现自己的ID和密码被盗或被第三方使用，应立即通知公司，并按照公司的指示（如有）进行操作。第12条（服务使用者的义务）
            1.服务使用者不得有以下行为： ①申请或更改时登记虚假信息 ②窃取他人信息
            ③向公司披露或发布淫秽或暴力信息、图片或其他违反公共秩序和道德的信息
            ④更改公司发布的信息 ⑤侵犯公司和其他第三方的知识产权
            ⑥违反其他法律和本使用条款的违法行为
            2.公司对服务使用者违反本条义务而产生的结果不承担责任。此外，如果给公司造成损失，服务使用者应对公司承担损害赔偿责任，公司可以通过法律程序暂停会员使用服务并要求损害赔偿等。
            第13条（会员的责任）
            1.会员自行承担使用和创建本服务以及本服务中提供的各种内容的风险，会员对通过本服务进行的所有行为及其结果负责。
            2.
            会员了解其他人可能会查看会员创建的内容，并且可以通过调整隐私设置来限制对内容的访问。
            3.
            会员对其用户内容以及由此产生的任何索赔负全部责任，并同意公司对任何用户内容或由此产生的任何索赔不承担任何责任或法律责任。
            4.
            公司有权随时以任何理由审查、确认和删除用户内容，但没有义务这样做。
            5.
            会员保留其用户内容的所有所有权。但是，通过向公司提交用户内容，会员授予公司不可撤销、非排他、全球性、永久性、免版税、可再授权和可转让的许可，以使用、复制、修改、改编、编辑、发布、创建衍生作品、分发、执行、推广、展示和显示此类用户内容在任何媒体或分发方法中，包括现在已知或以后开发的。
            6.
            会员知悉并同意，通过访问或使用本服务，会员可能会接触到他人发布的可能被视为冒犯性、猥亵或其他令人反感的内容，并同意承担此类风险。通过本公司网站或服务表达的观点并不一定代表本公司的观点。本公司不认可或支持会员或服务用户发布的任何特定内容。7.
            本公司将提供可能的安全措施来保护内容，但对于因内容披露而造成的任何损害，本公司概不负责。8.
            如果会员有以下任何行为，会员应自行承担责任和费用解决相关争议，本公司对此不承担任何责任。
            ① 上传或复制虚假、误导或违反公共秩序和道德的内容时 ②
            上传的内容等诽谤他人或侵犯他人隐私时 ③
            在公司或电子通信网络等上共享或分发第三方的照片或视频时 ④
            会员的行为侵犯他人知识产权、相关法律或本条款时 ⑤
            因其他原因侵犯他人权利时 第14条（会员等级）
            公司可以根据会员使用服务的活动设定会员等级，并可以根据等级区分服务使用和福利支付。
            第15条（应用内货币系统）
            1.应用内货币是在使用公司运营的服务过程中生成的，有效期、数量等根据个人活动而不同。
            2.应用内货币不是客户的流动资产，因此不能兑换成现金。如果发现是通过欺诈活动积累的，可能会被兑换或取消。
            3.
            应用内货币将在指定期限后自动失效。购买的应用内货币无法兑换回现金。
            4. 会员退出或丧失资格时，应用内货币将被取消且无法恢复。 5.
            应用内货币的累积、使用和有效期相关政策可能根据公司情况而更改。
            第16条（奖金支付）
            如果公司向会员支付奖金，用户可以在抽奖日后3个月内要求公司支付奖金。但是，如果公司就抽奖和奖金支付另行发布通知或公告，则应遵守该通知。
            第17条（与合作伙伴的关系）
            会员可以参加宣传合作公司产品等的活动，这是基于会员和合作公司之间的直接合同，公司不参与其中或负责解决纠纷。第18条（服务转让的限制）
            会员不得将服务使用协议项下的服务使用权或其他地位转让或赠与他人，亦不得将其作为抵押品提供。但公司服务可能因业务或其他运营原因而转让。
            第19条（内容创作准则及管理/限制）
            1.会员同意遵守公司可能随时更新的社区准则。
            2.内容创作应遵循以下准则： ① 注册色彩分析用的各种图像 ②
            注册个人色彩信息 ③ 注册会员特征信息 ④ 注册其他信息
            3.如果会员的内容包含违反信息通信网法、知识产权或其他法律的内容，内容权利人可以按照相关法律规定的程序向公司请求停止或删除该内容，公司将把该事实通知会员。
            4.
            公司判断根据前款提出异议的内容违反本条款或相关法律时，可通知会员并采取中止或暂时删除该内容等措施。5.
            如果对内容等提出异议或发生纠纷，导致会员根据本条规定暂停使用或删除内容等，公司将通知会员。6.
            公司终止服务或因运营原因，公司可在通知会员终止服务后，不另行保存地删除内容等。7.
            除本条款明确规定外，公司不授予任何明示或暗示的使用内容的权利。 8.
            除本条款另有明确规定外，会员同意不复制、翻印、翻印、插入框架、下载、传输、修改、展示、逆向工程、销售、参与销售、出租、租赁、出借、转让、分发、许可、再许可或以任何方式使用内容、服务或相关软件的全部或部分。第20条（知识产权归属和使用限制）1.
            公司创作的作品的版权和其他知识产权归公司所有。2.
            服务使用者不得在未经公司事先同意的情况下，通过复制、传输、出版、分发、广播或其他方式将通过公司和服务获得的信息（包括公司拥有知识产权的信息）用于盈利目的，或允许第三方用于盈利目的。3.
            公司可以直接免费使用会员创作的与商品等相关的所有内容等，或允许与公司另行签订合同的合作公司使用此类信息，会员特此同意。第21条（纠纷解决）
            1.
            公司应设置并运营损害赔偿处理机构，以反映服务用户提出的正当意见或投诉，并在发生损害时赔偿损害。
            2.
            公司应优先处理服务用户提出的投诉和意见。但如果难以迅速处理，公司应立即通知服务用户原因和处理时间表。
            第22条（管辖和适用法律） 1.
            公司与用户之间因电子商务纠纷而产生的诉讼，由用户提起诉讼时住址或（如无住址）居住地有管辖权的地方法院专属管辖。但是，如果用户提起诉讼时住址或居住地不明确，或者用户是外国居民，则应向《民事诉讼法》规定的有管辖权的法院提起诉讼。
            2.
            公司与用户之间提起的电子商务诉讼适用韩国法律。附则。本条款和条件自
            2025 年 5 月 8 日起生效。联系人：ask@ocollor.com
          </Typography>
        ) : props.language == 5 ? (
          <Typography variant="body1">
            使用條款 自 2025 年 5 月 8 日起生效 第 1 條（目的）
            1.本使用條款旨在規定公司與其會員之間在使用 Ocollor
            有限公司（以下簡稱「本公司」）提供的 Ocollor
            諮詢專案服務方面的權利、義務、責任和其他必要事項。
            2.會員同意遵守與使用本服務有關的韓國法律。
            3.公司個人資訊處理政策規範了公司資訊的收集和使用，適用於提供給公司的所有資訊。透過使用本服務，會員同意公司收集和使用資訊（如個人資訊處理政策中所述），包括將此類資訊傳輸到韓國和/或其他國家以進行儲存、處理和使用。作為提供服務的一部分，公司可能會發送某些通信，例如服務公告和管理訊息，這些通信被視為服務和會員服務帳戶的一部分，會員不能拒絕接收。第2條（定義）本使用條款中所使用的術語定義如下。未定義術語的解釋應受相關法律和服務特定準則的約束。相關法律和服務特定準則中未規定的事項應遵循一般慣例。
            1.「服務」是指「會員」無論安裝何種終端（包括可攜式終端、PC和電視等各種有線和無線設備）均可使用的Okolor諮詢計劃以及與Okolor諮詢計劃相關的基礎服務。
            2.「使用者」是指未註冊為會員（非會員）而使用本公司提供的服務的個人。
            3.「會員」是指同意本條款和條件並使用本公司提供的服務的個人。
            4.「服務用戶」是指用戶和會員。
            5.「內容」是指會員或Okolor提供的各種數位資訊。第3條（條款的具體化、說明及修改等）1.公司應將本條款的內容在公司網站上登載，以便服務使用者輕鬆理解，或透過其他方式通知會員，使其生效。
            2.公司在不違反《條款限制相關法》、《資訊通信網使用促進及資訊保護等相關法律》、《電子商務等消費者保護相關法律》、《消費者保護基本法》等相關法律的範圍內，可以修改本條款。
            3.公司修改條款時，應自修改條款適用日前30天起至適用日止，依第1項規定的方式，將修改後的條款與現行條款一併通知會員。但，若涉及會員權利或義務的重要條款發生變更，本公司應至少提前30天通知會員，並將修改後的條款寄至會員註冊的信箱地址。
            4.公司依前項規定，將修改後的條款通知或告知會員，會員未在條款變更適用日前表示拒絕即視為同意，會員未表示拒絕的，視為同意修改後的條款。
            5.會員不同意修改後的條款時，本公司無法適用修改後的條款內容，此時會員可以停止使用本服務並解除使用協議。
            6.同意本條款即表示同意透過公司及行動應用程式定期查看條款及營運政策的變更情況。會員應對條款的變更保持足夠的警惕，對於會員因不了解修改後的條款而遭受的損失，公司概不負責。第四條（個人資訊保護）
            1.
            公司在收集使用者的個人資訊時，僅收集提供服務所需的最低限度的個人資訊。
            2.
            本公司不會在使用者註冊會員時事先收集營運服務所需的資訊。但是，為了履行相關法律法規規定的義務需要進行身份驗證，且收集最低限度的特定個人資訊的情況下，不在此限。
            3.
            本公司在收集和使用服務用戶的個人資訊時，會事先將資訊的使用目的和範圍告知用戶，並取得其同意。
            4.
            本公司不得將收集的個人資訊用於營運服務及研究目的以外的目的，當出現新的使用目的或提供給第三方時，會在使用或提供時告知使用者其使用目的並取得其同意。但是，相關法律法規另有規定時，可能有例外情況。
            5.
            公司依第2款及第3款規定需要取得服務利用者的同意時，必須事先明示或告知個人資訊管理者的身分（所屬機構、姓名、電話號碼等聯絡方式）、資訊蒐集及使用目的、向第三人提供資訊的相關事項（接收者、提供目的、提供資訊內容）等，這些都符合《個人資訊保護法》和《
            6.
            服務利用者可以隨時要求閱覽或更正公司所持有的個人資料中的錯誤，公司有義務立即採取必要措施。若服務利用者要求更正錯誤，公司在錯誤更正前不得使用該個人資訊。
            7.
            本公司為保護個人資訊，將處理服務使用者個人資訊的人員限制在最低限度，並對因服務使用者個人資訊遺失、被竊、洩漏、未經同意提供給第三方或被竄改而給服務使用者造成的任何損害承擔全部責任。
            8.
            公司或從公司獲得個人資訊的第三方在達到收集或提供個人資訊的目的後，應立即銷毀個人資訊。
            9.
            本公司不得將個人資料的收集、使用及提供的同意框設定為預先選擇。此外，本公司將具體說明如果服務使用者拒絕同意個人資訊的收集、使用和提供，將被限制的服務，並且公司不會因為拒絕同意非必要收集項目的個人資訊的收集、使用和提供而限製或拒絕提供會員註冊等服務。
            10.
            會員同意，會員透過電子郵件或其他方式向本公司提供的任何有關本公司或本服務的回饋、建議、想法或其他資訊或資料均不屬於保密資訊，且屬於本公司的唯一財產。本公司有權不受限制地將此類資料和資訊用於任何目的（無論是否用於商業目的），而無需通知或向會員支付任何報酬。會員同意不放棄或主張其對向本公司提供的各種資訊和資料可能擁有的任何權利（包括版權或道德權利）。本公司歡迎使用者提出意見，但如果您希望獲得報酬或希望保留這些想法的所有權或主張，請勿與本公司分享。第5條（會員註冊）1.
            用戶使用以下方法申請會員資格。但公司可能會根據其營運的媒體和服務類型確定單獨的會員申請方法。
            ① 在公司規定的註冊表中填寫會員資料並表示同意本條款的方式 ②
            公司規定的其他方式
            2.公司將根據第1款規定申請加入會員的用戶註冊為會員，但符合下列情況之一的除外：
            ①
            申請人之前根據本條款第7條規定喪失會員資格的情況。但是，公司允許重新註冊會員的情況除外。
            ② 註冊時存在虛假、遺漏或不正確內容的情況。 ③
            判斷註冊會員會嚴重妨礙公司技術的情況。 3.
            會員註冊時間為公司批准到達會員的時間。 4.
            註冊資料發生變更時，會員必須在合理的時間內透過修改會員資訊的方式通知本公司。
            第6條（會員資格的退出和資格的喪失） 1.
            會員可以隨時向公司申請退出，公司將立即為其辦理退出手續。但是，當會員退出時，其擁有的個人內容和資訊等所有會員權益都將被取消。
            2.
            如果會員在退出前已經支付了服務或與服務相關的使用費，則該使用費將根據相關法律法規退還。但是，如果會員未申請退款就退出，由於相關記錄被刪除等原因，退款可能會變得困難，因此我們要求您在退出前完成所有必要的退款程序。此外，即使帳戶被註銷，已經發生的付款義務也不會免除。
            3.
            若服務被取消或暫停，本公司將盡合理努力通知會員並提供檢索內容的機會。
            4.
            退出會員資格後，會員資料將立即被銷毀。但是，在以下情況下，資訊將根據以下保留原因保留指定的期限。
            ① 基於相關法律法規的資訊保留事由 a. 國稅基本法、消費者保護法等 ②
            基於公司內部政策的信息保留事由
            a.保留項目：收集的會員信息，例如電話號碼、出生日期、性別、電子郵件和照片
            b.保留原因：防止欺詐和使用
            欺詐註冊：使用他人名義註冊或註冊虛假會員以參加名義註冊或多個虛假的名義
            c.詐欺使用：使用他人名義或註冊為虛假會員以進行欺詐目的（例如參加活動）並在內容、Q&A等上發布辱罵性語言或公司宣傳內容
            d.保留期限：1個月
            5.如果會員符合以下任何事由，公司可能會限製或暫停會員資格。 ①
            申請會員資格時註冊虛假資訊或竊取他人資訊的情況。 ②
            其他人幹擾公司的使用或竊取此類訊息，威脅電子商務秩序的情況。 ③
            利用公司實施法律或本條款禁止的行為或違反公共秩序和道德的行為。 ④
            屬於下列各項之一的行為，妨礙公司健全經營和服務運營時 a.
            散佈關於公司的毫無根據的虛假信息，損害公司名譽時。 c.
            對公司員工進行侮辱、謾罵、威脅、性騷擾等，妨礙公司業務運作時。 d.
            經常要求超過消費者機構公告的消費者糾紛解決標準的過高賠償時。
            會員發佈的內容屬於下列任何一項時：1）侵犯他人權利、名譽、信用或其他合法利益時；2）涉及犯罪行為或違反公共秩序和社會道德時；3）發布、宣傳或連結到非法內容、色情或對青少年設備有害媒體的網站時；4）與公司提供的產品和服務無關時；5）包含可能導致資訊和通訊設備有害媒體的網站時；使用合作公司利益製作的內容，但未依照本公司提供的營運政策標記為「廣告」或「贊助」；8)
            違反其他使用條款、公司提供的各項營運政策或相關法律法規。根據其他會員的舉報或公司自行判斷，會員的帳戶存取和使用可能會被暫停。暫停時間和是否可以再次使用將另行通知會員。
            7.
            公司限製或暫停會員資格後，如果重複兩次以上相同行為，或30天內未糾正原因，公司可以終止會員資格。若公司終止會員資格，會員註冊將被取消。在這種情況下，將在取消會員註冊前通知會員並給予至少30天的時間說明理由。第7條（對會員的通知）
            1.公司通知會員時，可透過會員事先與本公司約定的SNS帳號、電子郵件地址、手機號碼（簡訊、KakaoTalk帳號）等方式進行。
            2.公司在向不特定多數服務利用者通知的情況下，可以透過在服務畫面或公司公告欄上發布一周以上的方式代替個別通知。但是，對會員自身交易有重大影響的事項，將進行個別通知。
            第8條（服務的提供及變更） 1.公司提供以下服務業務。 ①提供色彩分析服務
            ②廣告服務業務 ③其他公司規定的業務
            2.公司僅為了讓服務利用者和合作公司進行商品等交易而提供商品等信息，對合作公司提供的商品等信息及一切販賣活動，公司不承擔任何責任。第9條（服務中斷）
            1.公司因資訊通訊設備的維護、檢查、更換、故障或通訊中斷等情況，可暫時中止提供服務。
            2.公司因第1款事由暫時中止提供服務，對用戶或第三方造成損失的，應當賠償損失。但是，如果公司能證明沒有故意或過失，則不在此限。
            3.公司因變更業務種類、放棄業務、公司間整合等事由無法提供服務時，應依第8條規定的方式通知會員。
            第10條（公司的義務）
            1.公司不得從事法律法規或本條款禁止的行為或違反公共秩序和道德的行為，並應依本條款盡力持續穩定地提供服務。
            2.公司必須具備保護使用者個人資訊的安全系統，以便使用者可以安全地使用公司服務。
            3.
            本公司對於會員在使用服務過程中提出的意見或投訴，如公司認為合理，必須予以處理。
            4.本公司將透過公告欄或其他公司認為適當的方式，就會員提出的意見或投訴，向會員通報處理過程及結果。第11條（會員關於ID和密碼的義務）1.會員有責任管理自己的ID和密碼。
            2.會員不得將自己的ID和密碼提供給第三方使用。
            3.如果會員發現自己的ID和密碼被盜或被第三方使用，應立即通知公司，並按照公司的指示（如有）進行操作。第12條（服務使用者的義務）
            1.服務使用者不得有以下行為： ①申請或更改時登記虛假信息 ②竊取他人信息
            ③向公司披露或發布淫穢或暴力信息、圖片或其他違反公共秩序和道德的信息
            ④更改公司發布的信息 ⑤侵犯公司和其他第三方的非法行為 ⑥
            2.公司對服務使用者違反本條義務而產生的結果不承擔責任。此外，如果對公司造成損失，服務使用者應對公司承擔損害賠償責任，公司可以透過法律程序暫停會員使用服務並要求損害賠償等。
            第13條（會員的責任）
            1.會員自行承擔使用和創建本服務以及本服務中提供的各種內容的風險，會員對透過本服務進行的所有行為及其結果負責。
            2.
            會員了解其他人可能會查看會員創建的內容，並且可以透過調整隱私設定來限制對內容的存取。
            3.
            會員對其使用者內容以及由此產生的任何索賠負全部責任，並同意本公司對任何使用者內容或由此產生的任何索賠不承擔任何責任或法律責任。
            4.
            本公司有權隨時以任何理由審查、確認和刪除使用者內容，但沒有義務這樣做。
            5.
            會員保留其使用者內容的所有所有權。但是，透過向公司提交使用者內容，會員授予公司不可撤銷、非排他、全球性、永久性、免版稅、可再授權和可轉讓的許可，以使用、複製、修改、改編、編輯、發布、創建衍生作品、分發、執行、推廣、展示和顯示此類用戶內容在任何媒體或分發方法中，包括現在已知或以後開發的。
            6.
            會員知悉並同意，透過存取或使用本服務，會員可能會接觸到他人發佈的可能被視為冒犯性、猥褻或其他令人反感的內容，並同意承擔此類風險。透過本公司網站或服務表達的觀點並不一定代表本公司的觀點。本公司不認可或支持會員或服務使用者所發布的任何特定內容。
            7.
            本公司將提供可能的安全措施來保護內容，但對於因內容揭露而造成的任何損害，本公司概不負責。
            8.
            若會員有以下任何行為，會員應自行承擔責任和費用解決相關爭議，本公司對此不承擔任何責任。
            ① 上傳或複製虛假、誤導或違反公共秩序和道德的內容時 ②
            上傳的內容等誹謗他人或侵犯他人隱私時 ③
            在公司或電子通信網絡等上共享或分發第三方的照片或視頻時 ④
            會員的行為侵犯他人知識產權、相關法律或本條款時 ⑤
            因其他原因侵犯他人權利時14公司可以根據會員使用服務的活動設定會員等級，並且可以根據等級區分服務使用和福利支付。
            第15條（應用內貨幣系統）
            1.應用內貨幣是在使用公司營運的服務過程中產生的，有效期限、數量等依個人活動而不同。
            2.應用內貨幣不是客戶的流動資產，因此不能兌換成現金。如果發現是透過詐欺活動累積的，可能會被兌換或取消。
            3.
            應用內貨幣將在指定期限後自動失效。購買的應用程式內貨幣無法兌換回現金。
            4. 會員退出或喪失資格時，應用程式內貨幣將被取消且無法恢復。 5.
            應用內貨幣的累積、使用和有效期限相關政策可能會根據公司情況而更改。
            第16條（獎金支付）
            如果公司向會員支付獎金，用戶可以在抽獎日後3個月內要求公司支付獎金。但是，如果公司就抽獎和獎金支付另行發布通知或公告，則應遵守該通知。
            第17條（與合作夥伴的關係）
            會員可以參加宣傳合作公司產品等的活動，這是基於會員和合作公司之間的直接合同，公司不參與其中或負責解決糾紛。第18條（服務轉讓的限制）
            會員不得將服務使用協議下的服務使用權或其他地位轉讓或贈與他人，亦不得將其作為抵押品提供。但公司服務可能因業務或其他營運原因而轉讓。
            第19條（內容創作準則及管理/限制）
            1.會員同意遵守公司可能隨時更新的社群準則。
            2.內容創作應遵循以下準則： ① 註冊色彩分析用的各種圖像 ②
            註冊個人色彩資訊 ③ 註冊會員特徵資訊 ④ 註冊其他資訊
            3.如果會員的內容包含違反資訊通訊網法、智慧財產權或其他法律的內容，內容權利人可以依照相關法律規定的程序向公司要求或刪除該公司要求提供該公司。
            4.
            公司判斷依前項提出異議的內容違反本條款或相關法律時，可通知會員並採取中止或暫時刪除該內容等措施。
            5.
            若對內容等提出異議或發生糾紛，導致會員依本條規定暫停使用或刪除內容等，本公司將通知會員。
            6.
            本公司終止服務或因營運原因，本公司可在通知會員終止服務後，不另行保存地刪除內容等。
            7. 除本條款明確規定外，本公司不授予任何明示或暗示的使用內容的權利。
            8.
            除本條款另有明確規定外，會員同意不複製、翻印、翻印、插入框架、下載、傳輸、修改、展示、逆向工程、銷售、參與銷售、出租、租賃、出借、轉讓、散佈、授權、再授權或以任何方式使用內容、服務或相關軟體的全部或部分。第20條（智慧財產權歸屬和使用限制）1.
            本公司創作的作品的版權和其他智慧財產權歸公司所有。 2.
            服務使用者不得在未經公司事先同意的情況下，透過複製、傳輸、出版、散佈、廣播或其他方式將透過公司和服務獲得的資訊（包括公司擁有知識產權的資訊）用於盈利目的，或允許第三方用於盈利目的。
            3.
            公司可以直接免費使用會員創作的與商品等相關的所有內容等，或允許與公司另行簽訂合約的合作公司使用此類信息，會員特此同意。第21條（爭議解決）
            1.
            公司應設置並經營損害賠償處理機構，以反映服務使用者提出的正當意見或投訴，並在發生損害時賠償損害。
            2.
            公司應優先處理服務使用者提出的投訴和意見。但如果難以迅速處理，公司應立即通知服務使用者原因和處理時間表。
            第22條（管轄及適用法律） 1.
            本公司與使用者之間因電子商務糾紛而產生的訴訟，由使用者提起訴訟時住址或（如無住址）居住地有管轄權的地方法院專屬管轄。但是，如果使用者提起訴訟時住址或居住地不明確，或者使用者是外國居民，則應向《民事訴訟法》規定的有管轄權的法院提起訴訟。
            2.
            本公司與使用者之間提起的電子商務訴訟適用韓國法律。附則。本條款和條件自
            2025 年 5 月 8 日起生效。聯絡人：ask@ocollor.com
          </Typography>
        ) : (
          ""
        )}
        <div className="TermsOfServiceAgreementModalBottom">
          <ButtonComponent
            fullWidth
            variant="contained"
            onClick={() => props.onClose(true)}
            className="MemberUpdateButton"
          >
            {props.language == 1
              ? "확인"
              : props.language == 2
              ? "Check"
              : props.language == 3
              ? "確認"
              : props.language == 4
              ? "查看"
              : props.language == 5
              ? "查看"
              : ""}
          </ButtonComponent>
          {props.cancel && (
            <ButtonComponent
              fullWidth
              variant="contained"
              onClick={() => props.onClose(false)}
              className="MemberDeleteButton"
            >
              {props.language == 1
                ? "취소"
                : props.language == 2
                ? "Cancel"
                : props.language == 3
                ? "キャンセル"
                : props.language == 4
                ? "消除"
                : props.language == 5
                ? "消除"
                : ""}
            </ButtonComponent>
          )}
        </div>
      </Box>
    </Modal>
  );
}
